export default {
  // Common
  common: {
    open: "مفتوح",
    from: "من",
    to: "إلى",
    deselectAll: "إلغاء التحديد",
    uploadFiles: "ارفع الملفات",
    appName: "التحكم في التكاليف",
    loading: "جاري التحميل...",
    error: "حدث خطأ",
    success: "تم بنجاح",
    save: "حفظ",
    saved: "تم الحفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    create: "إنشاء",
    update: "تحديث",
    search: "بحث",
    filter: "تصفية",
    clear: "مسح",
    apply: "تطبيق",
    reset: "إعادة تعيين",
    confirm: "تأكيد",
    close: "إغلاق",
    back: "رجوع",
    next: "التالي",
    previous: "السابق",
    yes: "نعم",
    no: "لا",
    all: "الكل",
    none: "لا شيء",
    select: "اختيار",
    selected: "محدد",
    actions: "إجراءات",
    status: "الحالة",
    active: "نشط",
    inactive: "غير نشط",
    pending: "قيد الانتظار",
    approved: "موافق عليه",
    rejected: "مرفوض",
    total: "الإجمالي",
    items: "العناصر",
    showMore: "عرض المزيد",
    showLess: "عرض أقل",
    noData: "لا توجد بيانات",
    noResults: "لم يتم العثور على نتائج",
    import: "استيراد",
    export: "تصدير",
    exporting: "جاري التصدير",
    fileFailedToUpload: "فشل تحميل الملف",
    exportPdf: "PDF",
    exporttPdf: "تصدير PDF",
    exportXlsx: "XLSX",
    exportCsv: "CSV",
    advancedFilters: "تصفية متقدمة",
    applyFilter: "تطبيق الفلتر",
    resetFilters: "إعادة تعيين الفلاتر",
    goToPage: "انتقل إلى الصفحة",
    show: "عرض",
    default: "افتراضي",
    ascending: "تصاعدي",
    descending: "تنازلي",
    oldest: "الأقدم",
    lowest: "الأقل",
    highest: "الأعلى",
    newest: "الأحدث",
    alphabeticalAscending: "ترتيب أبجدي تصاعدي",
    alphabeticalDescending: "ترتيب أبجدي تنازلي",
    chronologicalAscending: "ترتيب زمني تصاعدي",
    chronologicalDescending: "ترتيب زمني تنازلي",
    removeFilter: "إزالة المرشح",
    view: "عرض",
    exportExcel: "Excel",
    saveDraft: "حفظ كمسودة",
    discard_exit: "تجاهل وخروج",
    chooseFile: "اختر ملف",
    dropFilesHere: "اسحب الملفات هنا للرفع",
    submit: "إرسال",
    type: "النوع",
  },

  // Navigation
  nav: {
    dashboard: "لوحة التحكم",
    management: "الإدارة",
    stockManagement: "إدارة المخزون",
    inventory: "المخزون",
    orders: "الطلبات",
    orderManagement: "إدارة الطلبات",
    purchaseOrders: "أوامر الشراء",
    receivingQc: "الاستلام والجودة",
    dataManagement: "إدارة البيانات",
    items: "الأصناف",
    rawMaterials: "المواد الخام",
    preparedItems: "العناصر المؤهلة",
    preparationManagement: "إدارة التحضير",
    producedOutput: "المخرجات المنتجة",
    suppliers: "الموردين",
    costCenters: "مراكز التكلفة",
    expenses: "المصروفات",
    users: "المستخدمين",
    settings: "الإعدادات",
    profile: "الملف الشخصي",
    logout: "تسجيل الخروج",
    transfersManagement: "إدارة التحويلات",
    transfers: "التحويلات",
    incomingTransfers: "التحويلات الواردة",
    incomingRequests: "الطلبات الواردة",
    centralKitchen: "المطبخ المركزي",
    branch: "الفرع",
    requestsSent: "الطلبات المرسلة",
    branchToBranchTransfers: "تحويلات بين الفروع",
  },

  // Auth
  auth: {
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    logout: "تسجيل الخروج",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    rememberMe: "تذكرني",
    forgotPassword: "نسيت كلمة المرور؟",
    noAccount: "ليس لديك حساب؟",
    hasAccount: "لديك حساب بالفعل؟",
    signUp: "إنشاء حساب",
    signIn: "تسجيل الدخول",
    welcomeBack: "مرحباً بعودتك",
    loginSubtitle: "أدخل بيانات الاعتماد الخاصة بك للوصول إلى حسابك",
    registerSubtitle: "أنشئ حساباً جديداً للبدء",
    name: "الاسم الكامل",
  },

  // Validation
  validation: {
    required: "{{field}} مطلوب",
    email: "يرجى إدخال بريد إلكتروني صالح",
    minLength: "{{field}} يجب أن يكون {{min}} أحرف على الأقل",
    maxLength: "{{field}} يجب أن يكون {{max}} أحرف كحد أقصى",
    passwordMatch: "كلمات المرور غير متطابقة",
    invalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
    min: "{{field}} يجب أن يكون {{min}} على الأقل",
    max: "{{field}} يجب أن يكون {{max}} كحد أقصى",
    positive: "{{field}} يجب أن يكون رقماً موجباً",
    integer: "{{field}} يجب أن يكون رقماً صحيحاً",
  },

  // Dashboard
  dashboard: {
    title: "لوحة التحكم",
    welcome: "مرحباً، {{name}}",
    overview: "نظرة عامة",
    totalExpenses: "إجمالي المصروفات",
    totalBudget: "إجمالي الميزانية",
    budgetUtilization: "استخدام الميزانية",
    recentActivity: "النشاط الأخير",
    quickActions: "إجراءات سريعة",
    expensesByCategory: "المصروفات حسب الفئة",
    monthlyTrend: "الاتجاه الشهري",
    topCostCenters: "أعلى مراكز التكلفة",
    pendingApprovals: "الموافقات المعلقة",
  },

  // Items
  items: {
    applyMultipleFilters: "قم بتطبيق تصفيات متعددة لتضييق نطاق نتائجك",
    title: "المواد الخام",
    createItem: "إنشاء صنف",
    editItem: "تعديل الصنف",
    edit: {
      confirmModal: {
        title: "تأكيد تحديث الصنف",
        subtitle: "هل أنت متأكد أنك تريد حفظ هذه التغييرات؟",
        description: "سيتم تحديث تفاصيل الصنف.",
        cancel: "لا، الاستمرار في التعديل",
        confirm: "نعم، حفظ التغييرات",
      },
    },
    deleteItem: "حذف الصنف",
    deleteConfirm: "هل أنت متأكد من حذف هذا الصنف؟",
    cannotDeleteSingle: 'لا يمكن حذف "{{name}}"',
    cannotDeleteSingleDescription:
      "هذا العنصر قيد الاستخدام بالفعل ولا يمكن حذفه للحفاظ على السجلات الموجودة.",
    deleteSingleTitle: 'حذف "{{name}}"؟',
    deleteSingleSubtitle: "لم يتم استخدام هذا العنصر بعد.",
    deleteSingleDescription: "سيؤدي حذفه إلى إزالته نهائياً من النظام.",
    cannotDeleteMultiple: "لا يمكن حذف {{count}} عنصر محدد",
    cannotDeleteMultipleDescription:
      "جميع العناصر المحددة قيد الاستخدام بالفعل ولا يمكن حذفها.",
    deleteMultipleTitle: "حذف {{count}} عنصر محدد؟",
    deleteMultipleSubtitle: "لم يتم استخدام هذه العناصر بعد.",
    deleteMultipleDescription: "سيؤدي حذفها إلى إزالتها نهائياً من النظام.",
    deleteMultipleItems: "حذف العناصر",
    someItemsCantBeDeleted: "لا يمكن حذف بعض العناصر",
    someItemsCantBeDeletedSubtitle:
      "سيتم حذف العناصر التي لم يتم استخدامها فقط.",
    someItemsCantBeDeletedDescription:
      "بعض العناصر المحددة قيد الاستخدام بالفعل ولا يمكن حذفها.",
    itemsCanBeDeleted: "{{deletable}} من {{total}} عنصر يمكن حذفها",
    deleteEligibleItems: "حذف العناصر المؤهلة",
    deactivateItem: "تعطيل الصنف",
    deactivateMultipleItems: "تعطيل العناصر",
    cannotDeactivateSingle: 'لا يمكن تعطيل "{{name}}"',
    cannotDeactivateSingleDescription:
      "هذا الصنف قيد الاستخدام ويجب أن يبقى نشطًا.",
    deactivateSingleTitle: 'تعطيل "{{name}}"؟',
    deactivateSingleSubtitle: "لن يكون هذا الصنف متاحًا للاختيار.",
    deactivateSingleDescription: "يمكنك إعادة تفعيله لاحقًا عند الحاجة.",
    cannotDeactivateMultiple: "لا يمكن تعطيل {{count}} عنصر محدد",
    cannotDeactivateMultipleDescription:
      "جميع العناصر المحددة قيد الاستخدام ويجب أن تبقى نشطة.",
    deactivateMultipleTitle: "تعطيل {{count}} عنصر محدد؟",
    deactivateMultipleSubtitle: "لن تكون هذه العناصر متاحة للاختيار.",
    deactivateMultipleDescription: "يمكنك إعادة تفعيلها لاحقًا عند الحاجة.",
    someItemsCantBeDeactivated: "لا يمكن تعطيل بعض العناصر",
    someItemsCantBeDeactivatedSubtitle: "سيتم تعطيل العناصر غير المستخدمة فقط.",
    someItemsCantBeDeactivatedDescription:
      "بعض العناصر المحددة قيد الاستخدام ويجب أن تبقى نشطة.",
    deactivateEligibleItems: "تعطيل العناصر المؤهلة",
    itemName: "اسم الصنف",
    sku: "رمز المنتج",
    category: "الفئة",
    subcategory: "الفئة الفرعية",
    baseUOM: "وحدة القياس الأساسية",
    preferredSupplier: "المورد المفضل",
    costPerPurchaseUOM: "تكلفة الشراء",
    purchaseUOM: "وحدة الشراء",
    caseSize: "حجم العبوة",
    unitCost: "تكلفة الوحدة",
    selectCategory: "اختر الفئة",
    selectSubcategory: "اختر الفئة الفرعية",
    searchPlaceholder: "ابحث بالاسم، رمز المنتج، ...",
    searchValidationError: "الأحرف الخاصة غير مسموحة",
    tags: "الوسوم",
    totalItems: "الإجمالي: {{count}} صنف",
    sortByDate: "الفرز حسب التاريخ",
    selectedItems: "{{count}} محدد",
    status: "الحالة / ",
    mixedStatus: "مختلط",
    categorySubcategory: "الفئة / الفرعية",
    learnMore: "تعرف على المزيد",
    getStarted: "ابدأ",
    quickGuide: "دليل سريع لإنشاء العناصر",
    createItemDescription: "دليل خطوة بخطوة لإدارة العناصر بسرعة.",
    createItemContent: "هذه هي كيفية إضافة العناصر في 2 خطوات سهلة:",
    importantNotes: "ملاحظات مهمة",
    importantNote1: "يمكنك إضافة العناصر واحدة في فئة فرعية في كل مرة.",
    importantNote2: "يمكنك حفظ تقدمك كمسودة في أي وقت والاستمرار لاحقاً.",
    step1Title: "الخطوة 1",
    step1Subtitle: "أساسيات العنصر",
    step1Description1: "اختر فئة وفئة فرعية.",
    step1Description2:
      "إضافة اسماء العناصر باللغة الإنجليزية والعربية بناءً على الفئة الفرعية المختارة.",
    step2Title: "الخطوة 2",
    step2Subtitle: "إعداد العنصر",
    step2Description1: "اختر واحد أو أكثر من العناصر التي أضفتها في الخطوة 1.",
    step2Description2: "إضافة التكلفة لكل وحدة الشراء وحجم العبوة.",
    step2Description3: "احفظ تغييراتك قبل الانتقال إلى عنصر آخر.",
    needHelp: "هل تحتاج إلى مساعدة؟",
    importItems: "استيراد العناصر",
    importItemsSubtitle: "قم برفع مستند معبأ لإضافة عناصر متعددة دفعة واحدة.",
    importItemsDescription:
      "استخدم هذا القالب لضمان تنسيق عناصرك بشكل صحيح قبل الرفع.",
    downloadTemplate: "تحميل القالب",
    uploadFile: "رفع ملف",
    uploadDropzoneTitle:
      "انقر للرفع أو اسحب وأفلت ملف XLSX (الحد الأقصى لحجم الملف: 30 ميجابايت)",
    chooseFile: "اختر ملف",
    maxFileSizeErrorMessage:
      "حجم الملف يتجاوز الحد الأقصى المسموح به وهو 30 ميجابايت",
    noFileSelectedError: "يرجى اختيار ملف للاستيراد",
    fileShouldFollowTemplate: "يجب أن يتبع الملف القالب",
    pleaseUploadAndValidateFileFirst: "يرجى رفع ملف والتحقق منه أولاً",
    noDataInFile: "الملف لا يحتوي على بيانات",
    validationErrors: {
      worksheetNotFound: "لم يتم العثور على ورقة العمل",
      expectedColumns: "يجب أن يتبع الملف القالب",
      invalidHeaders: "رؤوس غير صحيحة: {{headers}}",
      categoryRequired: "الفئة مطلوبة",
      invalidCategory: "فئة غير صحيحة.",
      subcategoryRequired: "الفئة الفرعية مطلوبة",
      invalidSubcategory: "فئة فرعية غير صحيحة",
      itemNameEnRequired: "اسم العنصر بالإنجليزية مطلوب",
      itemNameEnEnglishOnly:
        "يجب أن يحتوي اسم العنصر بالإنجليزية على أحرف إنجليزية فقط",
      duplicateItemName: "تم العثور على اسم عنصر مكرر '{{name}}'",
      itemNameArRequired: "اسم العنصر بالعربية مطلوب",
      itemNameArArabicOnly:
        "يجب أن يحتوي اسم العنصر بالعربية على أحرف عربية فقط",
      baseUOMRequired: "وحدة القياس الأساسية مطلوبة",
      invalidBaseUOM: "وحدة قياس أساسية غير صحيحة",
      purchaseUOMRequired: "وحدة قياس الشراء مطلوبة",
      invalidPurchaseUOM: "وحدة قياس شراء غير صحيحة",
      packSizeRequired: "حجم العبوة مطلوب",
      packSizePositiveNumber: "يجب أن يكون حجم العبوة رقماً موجباً",
      parLevelRequired: "المستوى الأساسي مطلوب",
      parLevelPositiveNumber: "يجب أن يكون المستوى الأساسي رقماً موجباً",
      invalidTags: "علامات غير صحيحة: {{tags}}",
      errorReadingFile: "خطأ في قراءة الملف: {{error}}",
      unknownError: "خطأ غير معروف",
    },
    addingItems: "جاري إضافة العناصر...",
    addingItemsSubtitle: "قد يستغرق هذا بضع لحظات.",
    itemsProgress: "{{current}}/{{total}} عنصر",
    step1Content: "اختر الفئة والفئة الفرعية، ثم أدخل جميع أسماء العناصر.",
    step2Content:
      "قم بتعيين الوحدات وحجم الحزمة والعلامات، ثم قم بتطبيقها على العناصر الأخرى حيثما ينطبق ذلك .",
    addItemNames: "إضافة اسماء العناصر",
    leaveThisStep: "ترك هذه الخطوة؟",
    leaveThisStepSubTitle: "يمكن إضافة العناصر فقط تحت فئة فرعية واحدة.",
    leaveThisStepDescription:
      "العودة إلى تغيير الفئة الفرعية ستؤدي إلى حذف العناصر التي أضفتها.",
    stayOnThisStep: "البقاء على هذه الخطوة",
    leaveAndClear: "ترك ومسح العناصر",
    itemsCleared: "تم مسح العناصر.",
    itemsClearedDescription: "يمكنك الآن اختيار فئة فرعية مختلفة.",
    addItem_s: "إضافة عنصر/عناصر",
    itemNameEn: "اسم العنصر باللغة الإنجليزية",
    itemNameEnPlaceholder: "اسم العنصر باللغة الإنجليزية هنا",
    itemNameAr: "اسم العنصر باللغة العربية",
    itemNameArPlaceholder: "اسم العنصر باللغة العربية هنا",
    item: "عنصر",
    addItems: "إضافة العناصر",
    saveAsDraft: "حفظ كمسودة",
    saveDraftModalTitle: "تم حفظ المسودة!",
    saveDraftModalSubTitle: "تم حفظ تقدمك كمسودة.",
    saveDraftModalDescription: "يمكنك العودة لاحقاً لاستكمال تفاصيل العنصر.",
    saveDraftModalCancel: "إنهاء النموزج",
    saveDraftModalConfirm: "استكمال التعديلات",
    addedSuccessfully: "تم إضافة المورد بنجاح",
    addedSuccessfullyDescription: "المورد متاح الآن وجاهز للاستخدام.",
    addedItems: "عناصر مضافة",
    selectItems: "اختر العناصر",
    selected: "محدد",
    allItems: "جميع العناصر",
    addItemDetails: "إضافة تفاصيل الصنف",
    baseUOMHint: "الوحدة المستخدمة لتتبع المخزون",
    selectBaseUOM: "اختر الوحدة (كجم، لتر، قطعة، إلخ)",
    purchaseUOMHint: "الوحدة التي تشتري بها هذا الصنف عادة",
    selectPurchaseUOM: "اختر الوحدة (صندوق، كرتون، كيس،...",
    packSize: "حجم العبوة",
    packSizeHint: "كمية الصنف في وحدة شراء واحدة",
    packSizePlaceholder: "12 كجم لكل كرتونة",
    parLevel: "مستوى الحد الأدنى",
    parLevelHint:
      "الحد الأدنى من الكمية للحفاظ عليها في المخزون قبل الحاجة إلى إعادة الطلب.",
    minimum: "الحد الأدنى",
    tagsHint: "أضف تصنيفات لمساعدتك في تصنيف وفلترة هذا الصنف عبر النظام.",
    multipleSelected: "متعدد الاختيار",
    multipleInput: "قيم متعددة",
    itemsAddedSuccessfully: "تم إضافة العناصر بنجاح",
    itemsAddedSuccessfullyDescription:
      "تم إضافة العناصر, لكنها لم تربط بمورد/الموردين بعد.",
    itemsAddedSuccessfullyCancel: "عرض تفاصيل العنصر",
    itemsAddedSuccessfullyConfirm: "الانتقال إلى الموردين",
    itemsAddedSuccessfullyContent:
      "*للبدء في استخدامها, قم بربط العناصر بالمورد/الموردين.",
    exitWarningModalTitle: "الخروج بدون حفظ؟",
    exitWarningModalSubTitle: "يحتوي هذا النموزج على تفاصيل عناصر غير محفوظة.",
    exitWarningModalDescription:
      "الخروج الآن سيحذف بشكل دائم جميع البيانات المدخلة.",
    exitWarningModalCancel: "إلغاء والخروج",
    exitWarningModalConfirm: "حفظ كمسودة",
    unSavedDataWarningModalTitle: "تغييرات غير محفوظة",
    unSavedDataWarningModalSubTitle: "لم تحفظ تفاصيل العنصر بعد.",
    unSavedDataWarningModalDescription:
      "إلغاء الاختيار أو الاختيار لعنصر آخر سيؤدي إلى حذف البيانات المدخلة.",
    unSavedDataWarningModalCancel: "إلغاء التغييرات",
    unSavedDataWarningModalConfirm: "حفظ واستمرار",
    itemDetails: "تفاصيل الصنف",
    suppliers: "الموردين",
    activityLog: "سجل النشاط",
    statusDescription:
      "يتحكم في ما إذا كان هذا الصنف متاحًا للاستخدام ومرئيًا في النظام.",
    baseUOMDescription: "الوحدة المستخدمة لتتبع المخزون.",
    purchaseUOMDescription: "الوحدة التي تشتري بها هذا الصنف عادةً.",
    caseSizeDescription: "كمية الصنف في وحدة شراء واحدة.",
    tagsDescription:
      "أضف تصنيفات للمساعدة في تصنيف وتصفية هذا الصنف عبر النظام.",
    tagsAdded: "وسم مضاف",
    parLevelDescription:
      "الحد الأدنى للكمية المطلوب الاحتفاظ بها قبل إعادة الطلب.",
    backupSuppliers: "الموردين الاحتياطيين",
    supplierName: "اسم المورد",
    purchasePrice: "سعر الشراء",
    noSuppliers: "لا يوجد موردين معينين",
    notAssigned: "غير معين",
    noSuppliersDescription: "لم يتم تعيين أي موردين لهذا الصنف بعد.",
    goToSuppliers: "الذهاب إلى الموردين",
    noActivity: "لا يوجد نشاط بعد",
    noActivityDescription:
      "سيظهر سجل النشاط هنا بمجرد اتخاذ إجراءات على هذا الصنف.",
    source: "المصدر",
    by: "بواسطة",
    itemCreated: "إنشاء عنصر",
    itemUpdated: "تم تحديث العنصر",
    statusChanged: "تم تغيير الحالة",
    activityLogChangeFromTo: "{{field}}: {{from}} → {{to}}",
    activityLogEmptyValue: "—",
    activityLogIngredientDeleted: "تم حذف المكوّن {{name}}",
    activityLogIngredientAdded: "تمت إضافة المكوّن {{name}}",
    draftModalTitle: "لديك عناصر غير منتهية!",
    draftModalSubTitle: "لقد بدأت إنشاء العناصر ولم تنتهيها.",
    draftModalDescription:
      "لإنشاء عناصر جديدة، قم بإنهاء أو حذف المسودات الموجودة.",
    draftModalCancel: "إنشاء عناصر جديدة",
    draftModalConfirm: "استكمال التعديلات",
    exitWarningModalConfirmNoDraft: "استمرار",
    deleteAllItems: "حذف الكل",
    errors: {
      nameEnRequired: "الاسم بالإنجليزية مطلوب",
      englishOnly: "يرجى إدخال أحرف إنجليزية فقط",
      nameArRequired: "الاسم بالعربية مطلوب",
      arabicOnly: "يرجى إدخال أحرف عربية فقط",
      duplicateName: "اسم العنصر هذا موجود مسبقاً",
      packSizeRequired: "حجم العبوة مطلوب",
      greaterThanZero: "حجم العبوة يجب أن يكون أكبر من صفر",
      parLevelRequired: "مستوى الحد الأدنى مطلوب",
      positiveNumber: "مستوى الحد الأدنى يجب أن يكون أكبر من صفر",
    },
    deletedSingleSuccess: "تم حذف {{name}} بنجاح.",
    deletedMultipleSuccess: "تم حذف العناصر بنجاح.",
    activatedSingleSuccess: "تم تفعيل {{name}} بنجاح.",
    activatedMultipleSuccess: "تم تفعيل العناصر بنجاح.",
    deactivatedSingleSuccess: "تم إلغاء تفعيل {{name}} بنجاح.",
    deactivatedMultipleSuccess: "تم إلغاء تفعيل العناصر بنجاح.",
    deleteDraft: "حذف المسودة",
    deleteDraftDescription:
      "لم يتم إرسال هذه المسودة بعد. سيؤدي حذفها إلى إزالة جميع التغييرات المحفوظة نهائيًا.",
    deleteDraftSubtitle: "لا يمكن التراجع عن هذا الإجراء.",
    confirmDeleteDraft: "نعم، احذف المسودة",
    cancelDeleteDraft: "لا، الاحتفاظ بالمسودة",
    draftDeleted: "تم حذف المسودة",
    draftDeletedDescription: "تمت إزالة المسودة بنجاح.",
    export: {
      status: "الحالة",
      itemName: "اسم الصنف",
      sku: "رمز المنتج",
      category: "الفئة",
      subcategory: "الفئة الفرعية",
      preferredSupplier: "المورد المفضل",
      purchaseUOM: "وحدة الشراء",
      purchasePrice: "سعر الشراء",
      unitCost: "تكلفة الوحدة",
    },
  },

  // Suppliers
  suppliers: {
    supplierDetails: "تفاصيل المورد",
    suppliers: "الموردين",
    addedSuccessfully: "تم إضافة المورد بنجاح",
    addedSuccessfullyDescription: "المورد متاح الآن وجاهز للاستخدام.",
    updatedSuccessfully: "تم تحديث المورد بنجاح",
    updatedSuccessfullyDescription: "تم حفظ تغييرات المورد.",
    submit: "حفظ المورد",
    purchaseUOMPackSize: "وحدة الشراء / حجم العبوة",
    supplier: "المورد",
    pickDate: "اختر تاريخ",
    title: "الموردين",
    createSupplier: "إنشاء مورد",
    editSupplier: "تعديل مورد",
    supplierName: "اسم المورد",
    code: "الرمز",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    address: "العنوان",
    quickGuide: "دليل سريع لإنشاء الموردين",
    createSupplierDescription: "دليل خطوة بخطوة لإعداد وإدارة مورديك بسهولة.",
    createSupplierContent: "إليك كيفية إنشاء مورد في 4 خطوات بسيطة فقط:",
    learnMore: "اعرف المزيد",
    getStarted: "ابدأ",
    step1Title: "الخطوة 1",
    step1title: "معلومات المورد.",
    step2title: "معلومات الاتصال.",
    step1Subtitle: "معلومات المورد.",
    step1Description1: "أدخل التفاصيل الأساسية للمورد مثل الاسم والنوع",
    step2Title: "الخطوة 2",
    step2Subtitle: "معلومات الاتصال.",
    step2Description1: "أضف تفاصيل الاتصال للتواصل مع المورد.",
    step2Description2: "يمكنك اختيارياً تضمين شخص اتصال للتواصل المباشر.",
    step3Title: "الخطوة 3",
    step3Subtitle: "العقد.",
    step3Description1: "اختر نوع العقد المناسب للمورد.",
    step3Description2: "إن أمكن، أضف تواريخ العقد وقم بتحميل وثيقة العقد.",
    step4Title: "طعام / إضافة الأسعار للعناصر",
    step4: "الخطوة 4",
    step4Subtitle: "إضافة العناصر والأسعار.",
    step4Description1:
      "اختر العناصر التي تشتريها من هذا المورد من فئة فرعية واحدة أو أكثر.",
    step4Description2: "حدد أسعار الشراء للعناصر، بما في ذلك التسعير بالجملة.",
    step1ProgressTitle: "أدخل التفاصيل الأساسية ونوع المورد.",
    step2ProgressTitle: "أضف تفاصيل الاتصال للتواصل مع المورد.",
    step3ProgressTitle: "حدد نوع العقد وأرفق تفاصيل الاتفاقية، إن أمكن.",
    step4ProgressTitle: "اختر العناصر التي تشتريها من هذا المورد وحدد أسعارها.",
    importantNotes: "ملاحظات مهمة",
    importantNote1:
      "الأسعار المحددة في العقود الثابتة مقفلة لجميع الطلبات المشتراة",
    importantNote2: "يمكنك حفظ تقدمك كمسودة في أي وقت والمتابعة لاحقاً",
    editQuickGuide: "دليل سريع لتعديل الموردين",
    editSupplierDescription: "دليل خطوة بخطوة لتحديث بيانات المورد بسهولة.",
    editSupplierContent: "إليك كيفية تعديل مورد في 4 خطوات:",
    editStep1Description1:
      "حدّث اسم المورد ونوعه ورقم الضريبة والمستندات القانونية.",
    editStep2Description1:
      "حدّث رقم الهاتف والبريد الإلكتروني والموقع وشخص الاتصال.",
    editStep2Description2: "يمكنك تحديث شخص الاتصال أو إضافته إن لزم.",
    editStep3Description1: "حدّث نوع العقد وتواريخه ومستندات العقد.",
    editStep3Description2: "تأكد من اكتمال الحقول الإلزامية قبل الحفظ.",
    editStep4Description1:
      "أضف أو أزل أصنافاً، وأضف وحدة شراء / حجم عبوة جديداً، ثم أضف سعراً للمتغير الجديد.",
    editStep4Description2:
      "يمكنك تغيير نوع المورد (رئيسي / احتياطي) من ربط الأصناف.",
    editImportantNote1:
      "تُعرض أحدث بيانات المورد في الشاشات الحالية والمعاملات الجديدة.",
    editImportantNote2:
      "المعاملات المعتمدة والتاريخية تحتفظ بالبيانات التي سُجّلت وقت إنشائها.",
    needHelp: "تحتاج مساعدة؟",
    englishName: "الاسم بالإنجليزية",
    englishNamePlaceholder: "أدخل اسم المورد بالإنجليزية",
    arabicName: "الاسم بالعربية",
    arabicNamePlaceholder: "أدخل اسم المورد بالعربية",
    supplierType: "نوع المورد",
    mainSupplier: "مورد رئيسي",
    mainSupplierDescription:
      "المورد الأساسي المستخدم كافتراضي ويتم إعطاؤه الأولوية أثناء الطلب.",
    backupSupplier: "مورد احتياطي",
    backupSupplierDescription:
      "مورد بديل يُستخدم عندما يكون المورد الرئيسي غير متاح أثناء الطلب.",
    trnVatNumber: "رقم السجل الضريبي / ضريبة القيمة المضافة",
    trnVatNumberDescription: "يُستخدم لأغراض الضرائب والفواتير.",
    trnVatNumberPlaceholder: "أدخل رقم السجل الضريبي / ضريبة القيمة المضافة",
    legalDocuments: "المستندات القانونية",
    legalDocumentsDescription:
      "قم بتحميل المستندات مثل السجل التجاري وبطاقة الضرائب.",
    legalDocumentsHint:
      "الصيغ: PDF، DOC، DOCX، الحد الأقصى لحجم الملف: 50 ميجابايت.",
    dropzoneText: "اسحب الملفات هنا للتحميل",
    // Step 2 - Contact Information
    contactInformation: "معلومات الاتصال",
    contactPerson: "شخص الاتصال",
    phoneNumber: "رقم الهاتف",
    phonePlaceholder: "XX-XXXX-XXXX",
    emailPlaceholder: "text@domain.com",
    location: "الموقع",
    country: "الدولة",
    selectCountry: "اختر",
    uae: "الإمارات",
    unitedArabEmirates: "الإمارات العربية المتحدة",
    city: "المدينة",
    selectCity: "اختر",
    addressPlaceholder: "رقم المبنى، اسم الشارع، الحي/المنطقة",
    addressHint: "0/50 حرف",
    addContactPerson: "إضافة شخص اتصال",
    addContactPersonHelper: "حدد هذا المربع لتوفير جهة اتصال أساسية للمورد.",
    contactPersonDetails: "تفاصيل شخص الاتصال",
    editContactPerson: "تعديل شخص الاتصال",
    contactPersonName: "اسم شخص الاتصال",
    contactPersonNamePlaceholder: "جون دو",
    contactPersonPhone: "هاتف شخص الاتصال",
    contactPersonEmail: "بريد شخص الاتصال",
    saveContact: "حفظ",
    addAnotherPerson: "إضافة شخص آخر",
    deleteContactPersonTitle: 'حذف "{{name}}"؟',
    deleteContactPersonSubTitle: "هل أنت متأكد من حذف شخص الاتصال هذا؟",
    deleteContactPersonSubTitleDescription: "لا يمكن التراجع عن هذا الإجراء.",
    deletePerson: "حذف الشخص",
    contactPersonRemovedSuccess: '"{{name}}" تم حذفه بنجاح.',
    // Step 3 - Contract
    contractDetails: "تفاصيل العقد",
    contractType: "نوع العقد",
    fixedPriceAgreement: "اتفاقية سعر ثابت",
    fixedPriceAgreementDescription:
      "عقد بسعر محدد لا يتغير على مدار فترة الاتفاقية.",
    standardSupplier: "مورد قياسي",
    standardSupplierDescription:
      "مورد بدون عقد رسمي، يوفر السلع أو الخدمات على أساس مرن.",
    priceLockScope: "نطاق قفل السعر",
    priceLockDescription:
      "الأسعار المحددة هنا مقفلة ولا يمكن تغييرها عند إنشاء أوامر الشراء.",
    contractDate: "تاريخ العقد",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    contractDocuments: "مستندات العقد",
    noUploadedDocuments: "لا يوجد مستندات مرفقة",
    documents: "المستندات",
    uploadFiles: "تحميل الملفات",
    contractDocumentsHint:
      "الصيغ: PDF، DOC، DOCX. الحد الأقصى لحجم الملف: 50 ميجابايت.",
    totalSuppliers: "مجموع: {{count}} موردين",
    category: "الفئة",
    contractStatus: "حالة العقد",
    upcoming: "قادم",
    expired: "منتهي",
    assignedItemCount: "العناصر المعينة",
    actions: "الإجراءات",
    emptySuppliers: "لا يوجد موردين معينين",
    noStatus: "لا يوجد",
    searchPlaceholder: "بحث باسم المورد",
    statusChangedSuccessfully: "تم تغيير حالة المورد بنجاح.",
    main: "رئيسي",
    backup: "احتياطي",
    selectSupplierType: "اختر نوع المورد",
    deactivateSingleTitle: 'إلغاء تنشيط "{{name}}"?',
    deactivateSingleSubtitle: "هذا المورد لم يتم استخدامه بعد.",
    deactivateSingleDescription:
      "بمجرد إلغاء التنشيط، لن يكون متاحًا للاختيار.",
    deactivateSupplier: "إلغاء تنشيط المورد",
    deactivateMultipleTitle: "إلغاء تنشيط {{count}} موردين؟",
    deactivateMultipleSubtitle: "هذه الموردين لم يتم استخدامهم بعد.",
    deactivateMultipleDescription:
      "بمجرد إلغاء التنشيط، لن يكون متاحًا للاختيار.",
    deactivateMultipleSuppliers: "إلغاء تنشيط الموردين",
    deletedSuccessfully: "تم حذف الموردين بنجاح.",
    deleteSingleTitle: 'حذف "{{name}}"?',
    deleteSingleSubtitle: "هذا المورد لم يتم استخدامه بعد.",
    deleteSingleDescription: "بمجرد حذفه، سيتم إزالته نهائياً من النظام.",
    deleteMultipleTitle: "حذف {{count}} موردين؟",
    deleteMultipleSubtitle: "هذه الموردين لم يتم استخدامهم بعد.",
    deleteMultipleDescription: "بمجرد حذفهم، سيتم إزالتهم نهائياً من النظام.",
    deleteMultipleSuppliers: "حذف الموردين",
    deleteSupplier: "حذف المورد",
    activityLogCreated: "تم إنشاء المورد",
    activityLogUpdated: "تم تحديث المورد",
    activityLogDescSetActive: "تم تعيين المورد إلى نشط",
    activityLogDescSetInactive: "تم تعيين المورد إلى غير نشط",
    activityLogStatusChanged: "تم تغيير الحالة",
    activityLogChangeFromTo: "{{field}}: {{from}} → {{to}}",
    activityLogEmptyValue: "—",
    noSuppliersMatchYourFilter: "لا يوجد موردين يطابقون المعايير المحددة",
    assignedItems: "العناصر المعينة",
    deletedSingleSuccess: "تم حذف {{name}} بنجاح.",
    deletedMultipleSuccess: "تم حذف الموردين بنجاح.",
    activatedSingleSuccess: "تم تفعيل {{name}} بنجاح.",
    activatedMultipleSuccess: "تم تفعيل الموردين بنجاح.",
    deactivatedSingleSuccess: "تم إلغاء تفعيل {{name}} بنجاح.",
    deactivatedMultipleSuccess: "تم إلغاء تفعيل الموردين بنجاح.",
    deleteDraft: "حذف المسودة",
    deleteDraftDescription:
      "هل أنت متأكد من حذف هذه المسودة؟ سيتم فقدان جميع معلومات المورد.",
    deleteDraftSubtitle: "لا يمكن التراجع عن هذا الإجراء.",
    cancelDeleteDraft: "إلغاء",
    confirmDeleteDraft: "حذف المسودة",
    draftDeleted: "تم حذف المسودة",
    draftDeletedDescription: "تمت إزالة المسودة بنجاح.",
    type: "النوع",
    date: "التاريخ",

    tabs: {
      assignedItems: "العناصر المعينة",
      details: "التفاصيل",
    },
    details: {
      items: "عناصر",
      contractDetails: "تفاصيل العقد",
      noDate: "لا يوجد تاريخ محدد",
      activityLog: "سجل الأنشطة",
      basicDetails: "التفاصيل الأساسية",
      supplierContacts: "جهات اتصال المورد",
      legalDocs: "المستندات القانونية",
      trn: "رقم الضريبة / القيمة المضافة",
    },

    validation: {
      englishNameRequired: "الاسم بالإنجليزية مطلوب",
      arabicNameRequired: "الاسم بالعربية مطلوب",
      supplierTypeRequired: "نوع المورد مطلوب",
      trnVatNumberNumericOnly:
        "يجب أن يحتوي رقم السجل الضريبي / ضريبة القيمة المضافة على أرقام فقط",
      trnVatNumberMaxDigits:
        "يجب ألا يتجاوز رقم السجل الضريبي / ضريبة القيمة المضافة 15 رقمًا",
      trnVatNumberLength:
        "يجب ألا يتجاوز رقم السجل الضريبي / ضريبة القيمة المضافة 15 رقمًا",
      fileSizeExceeded:
        "يتجاوز حجم الملف الحد الأقصى المسموح به وهو 50 ميجابايت",
      duplicateFile: "تم اكتشاف ملف مكرر. تمت إضافة هذا الملف بالفعل",
      phoneRequired: "رقم الهاتف مطلوب",
      phoneInvalid: "يجب أن يحتوي رقم الهاتف على أرقام فقط",
      phoneLength: "يجب أن يكون رقم الهاتف 10 أرقام بالضبط",
      mobileFormatNotValid: "تنسيق الجوال غير صالح",
      emailInvalid: "يرجى إدخال عنوان بريد إلكتروني صالح",
      cityRequired: "المدينة مطلوبة",
      addressRequired: "العنوان مطلوب",
      contactPersonNameRequired: "اسم شخص الاتصال مطلوب",
      contactPersonNameNotNumbersOnly:
        "اسم شخص الاتصال لا يمكن أن يكون أرقاماً فقط",
      noSpecialChars: "الأحرف الخاصة ليست مسموح بها",
      contactPersonDuplicate: "تم إضافة شخص الاتصال هذا بالفعل",
      contractTypeRequired: "نوع العقد مطلوب",
      startDateRequired: "تاريخ البدء مطلوب",
      endDateRequired: "تاريخ الانتهاء مطلوب",
      endDateAfterStart: "يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء",
      contractDocumentsRequired:
        "مستند عقد واحد على الأقل مطلوب لاتفاقية السعر الثابت",
      duplicateVariants:
        "تم العثور على متغيرات مكررة. لا يمكن أن يحتوي نفس العنصر على متغيرات متعددة بنفس الوحدة وحجم العبوة والسعر.",
      duplicateVariantsForItem:
        'العنصر "{{itemName}}" يحتوي على متغيرات مكررة بنفس الوحدة وحجم العبوة.',
      purchasePriceMustBeGreaterThanZero: "يجب أن يكون سعر الشراء أكبر من 0",
    },
    itemsAddedSuccessfully: "تمت إضافة العناصر بنجاح",
    addItemsModal: {
      noItemsToAdd: "لا يوجد عناصر لإضافة",
      title: "إضافة عناصر للمورد",
      description:
        "اختر العناصر من فئة فرعية واحدة أو أكثر لتعيين تسعير المورد.",
      selectCategory: "اختر الفئة",
      chooseItems: "اختر العناصر للإضافة",
      addedItems: "العناصر المضافة",
      addAllItems: "إضافة جميع العناصر",
      removeAll: "إزالة الكل",
      addItems: "إضافة العناصر",
      searchPlaceholder: "بحث",
      noItemsFound: "لم يتم العثور على عناصر",
      allItemsAdded: "تمت إضافة جميع العناصر",
      addItemsPlaceholder: "أضف عناصر لتظهر هنا",
      itemsSelected: "{{count}} عنصر/ات محدد/ت",
      itemsCount: "{{selected}}/{{total}}",
      itemsTotal: "{{count}} عناصر",
    },
    addItemsTable: {
      baseUnit: "الوحدة الأساسية",
      packSize: "حجم الحزمة",
      purchasePrice: "سعر الشراء",
      supplierRole: "دور المورد",
      main: "رئيسي",
      backup: "احتياطي",
    },
    addPricesToItems: "طعام / إضافة أسعار للعناصر",
    itemsSavedSuccessfully: "تم حفظ العناصر بنجاح",
    deleteAllItems: "حذف الكل",
    removeAllItems: "إزالة جميع العناصر",

    bulkActions: {
      selected: "محدد",
      applySameType: "تطبيق نفس النوع على العناصر المحددة",
      applySamePrice: "تطبيق نفس السعر على العناصر المحددة",
      apply: "تطبيق",
      deleteSelected: "حذف المحدد",
      mixed: "مختلط",
      roleApplied: "تم تطبيق الدور بنجاح",
      priceApplied: "تم تطبيق السعر بنجاح",
      itemsDeleted: "تم حذف العناصر المحددة بنجاح",
    },
    addVariant: {
      title: "إضافة متغير شراء",
      description: "حدد وحدة جديدة وحجم عبوة لهذا العنصر.",
      purchaseUnit: "وحدة الشراء",
      selectUnit: "اختر الوحدة (صندوق، كرتون، كيس، إلخ)",
      packSize: "حجم العبوة",
      packSizePlaceholder: "12 كجم لكل كرتون",
      purchasePrice: "سعر الشراء",
      addAnother: "إضافة متغير آخر",
      clearAll: "مسح الكل",
      addVariants: "إضافة متغير/ات",
      addNewUnitSize: "إضافة وحدة/حجم جديد",
      selectUnitSize: "اختر الوحدة / الحجم",
      duplicateError: "إدخال مكرر",
      alreadyExistsError: "هذا المتغير موجود مسبقاً لهذا العنصر",
      successToast: "تمت إضافة المتغيرات بنجاح",
      overrideTooltip: "يمكنك تعديل وحدة الشراء وحجم العبوة.",
    },
    // Unsaved Changes Modals
    exitWithoutSaving: "الخروج بدون حفظ؟",
    unsavedChanges: "تغييرات غير محفوظة",
    formContainsUnsavedItems: "يحتوي هذا النموذج على تفاصيل عناصر غير محفوظة.",
    haventSavedItems: "لم تقم بحفظ العناصر والأسعار المضافة بعد.",
    exitingWillDelete:
      "الخروج الآن سيؤدي إلى حذف جميع البيانات المدخلة بشكل دائم.",
    goingBackWillRemove: "إذا عدت للخلف، سيتم إزالة جميع العناصر والأسعار",
    discardAndExit: "تجاهل والخروج",
    discardChanges: "تجاهل التغييرات",
    saveDraft: "حفظ كمسودة",
    draft: "مسودة",
    saveAndGoBack: "حفظ والعودة",
    saveDraftModalTitle: "تم حفظ المسودة!",
    saveDraftModalSubTitle: "تم حفظ تقدمك كمسودة.",
    saveDraftModalDescription: "يمكنك العودة لاحقاً لاستكمال تفاصيل المورد.",
    saveDraftModalCancel: "إنهاء النموذج",
    saveDraftModalConfirm: "استكمال التعديلات",
    draftModalConfirm: "استكمال النموذج",
    itemsAdded: "عناصر مضافة",
    submitSupplier: "إرسال المورد",
    saveSupplier: "حفظ المورد",
    saveAsDraft: "حفظ كمسودة",
    draftModalCancel: "إنشاء مورد جديد",
    errorBoundary: {
      title: "حدث خطأ أثناء تحميل نموذج المورد.",
      description:
        "قد لا تكون تغييراتك قد تم حفظها. يرجى تحديث الصفحة والمحاولة مرة أخرى.",
      reload: "تحديث الصفحة",
    },
  },

  // Purchase Orders
  purchaseOrders: {
    title: "أوامر الشراء",
    poNumber: "رقم أمر الشراء",
    supplierName: "اسم المورد",
    orderType: "نوع الطلب",
    expectedDeliveryDate: "تاريخ التسليم المتوقع",
    actualDeliveryDate: "تاريخ التسليم الفعلي",
    totalAmount: "المبلغ الإجمالي",
    orderStatus: "حالة الطلب",
    supplier: "المورد",
    creationDate: "تاريخ الإنشاء",
    status: {
      label: "الحالة",
      pending: "قيد الانتظار",
      completed: "مكتمل",
      rejected: "مرفوض",
      cancelled: "ملغي",
      canceled: "ملغي",
      accepted: "مقبول",
      acceptedPartial: "مقبول جزئياً",
      completedCloseShort: "مكتمل (مغلق جزئياً)",
    },
    orderTypes: {
      daily: "يومي",
      weekly: "أسبوعي",
      monthly: "شهري",
      custom: "مخصص",
    },
    searchPlaceholder: "البحث برقم أمر الشراء أو اسم المورد",
    selectSupplier: "اختر المورد",
    selectStatus: "اختر الحالة",
    selectDate: "اختر تاريخ محدد",
    date: "التاريخ",
    createOrder: "إنشاء طلب",
    results: "النتائج: {{count}} طلب",
    total: "الإجمالي: {{count}} طلب",
    exportSuccess: "اكتمل التصدير. تم تنزيل الملف بنجاح",
    emptyState: {
      title: "لا توجد أوامر شراء متاحة بعد.",
      message: "لا توجد أوامر شراء متاحة بعد.",
      createButton: "إنشاء أمر شراء",
    },
    details: {
      title: "تفاصيل أمر الشراء",
      mainTabs: {
        orderList: "قائمة الطلب",
        infoNotes: "المعلومات والملاحظات",
      },
      tabs: {
        orderInfo: "معلومات الطلب",
        supplier: "تفاصيل المورد",
        notes: " ملاحظات & التعليمات ",
      },
      orderInfo: {
        title: "معلومات الطلب",
        statusPending: "قيد الانتظار",
        statusPendingMessage:
          "هذا أمر الشراء في انتظار تأكيد الاستلام ومراقبة الجودة.",
        statusCancelled: "ملغي",
        statusCancelledMessage:
          "تم إلغاء أمر الشراء هذا ولن يتم المتابعة إلى الاستلام.",
        statusRejected: "مرفوض",
        statusRejectedMessage:
          "تم رفض أمر الشراء هذا ولم تتم الموافقة على معالجته.",
        createdOn: "تاريخ الإنشاء",
        createdBy: "أنشئ بواسطة",
        expectedDeliveryDate: "تاريخ التسليم المتوقع",
        orderType: "نوع الطلب",
        customOrderDate: "التاريخ المخصص",
        reasonForRejection: "سبب الرفض:",
        rejectedBy: "رفض بواسطة",
        actualDeliveryDate: "تاريخ التسليم الفعلي",
        receivedBy: "تم استلام بواسطة",
        statusCompletedShort: "مكتمل (مغلق جزئياً)",
        statusCompletedShortMessage:
          "تم إغلاق أمر الشراء هذا مع عدم استلام بعض العناصر بالكامل.",
      },
      supplier: {
        contractDetails: "تفاصيل العقد",
        type: "النوع",
        date: "التاريخ",
        supplierContacts: "جهات اتصال المورد",
        phoneNumber: "رقم الهاتف",
        email: "البريد الإلكتروني",
        address: "العنوان",
        contactPerson: "الشخص المسؤول",
      },
      notes: {
        internalNotes: "ملاحظات داخلية",
        forSupplier: "للمورد",
        documents: "المستندات",
      },
      orderList: {
        title: "ملخص الطلب",
        itemName: "اسم العنصر",
        sku: "رمز المنتج",
        purchaseUOM: "وحدة الشراء",
        packSize: "حجم العبوة",
        purchasePrice: "سعر الشراء",
        quantity: "الكمية",
        lineSubtotal: "المجموع الفرعي",
        finalSubtotal: "الإجمالي النهائي",
        ordered: "تم طلبه",
        originalSubtotal: "المجموع الأصلي",
        accepted: "تم الموافقة عليه",
        orderBreakdown: "تفاصيل الطلب",
        delivered: "تم الاستلام",
        remaining: "المتبقي",
        rejected: "تم الرفض",
        status: "الحالة",
        rejectionReason: "سبب الرفض",
        viewReason: "عرض السبب",
        rejectionDetails: "تفاصيل الرفض",
        rejectedItemsCount: "{{count}} مرفوض",
      },
      financial: {
        paymentDetails: "ملخص الدفع",
        title: "تفاصيل سعر الطلب",
        priceBeforeVAT: "السعر قبل الضريبة",
        discount: "الخصم",
        subtotal: "المجموع الفرعي",
        deliveryFees: "رسوم التوصيل",
        vat: "الضريبة",
        grandTotal: "الإجمالي",
        finalSettledAmount: "إجمالي المبلغ المُسوّى النهائي",
        originalPayment: "الدفع الأصلي",
        finalPayment: "الدفع النهائي",
        originalPOAmount: "مبلغ أمر الشراء الأصلي",
      },
      actions: {
        cancel: "إلغاء",
        exportPdf: "تصدير PDF",
        reOrder: "إعادة الطلب",
        startReceiving: "بدء الاستلام",
      },
      cancelModal: {
        title: "إلغاء الطلب؟",
        message: "سيؤدي إلغاء هذا الطلب إلى إيقافه عن المتابعة إلى الاستلام.",
        warning: "لا يمكن التراجع عن هذا الإجراء.",
        keepOrder: "الاحتفاظ بالطلب",
        continueToCancel: "المتابعة للإلغاء",
      },
      cancelSuccess: {
        title: "تم إلغاء الطلب",
        message: "لن يتم متابعة الطلب إلى الاستلام.",
      },
    },
    export: {
      poNumber: "رقم أمر الشراء",
      supplierName: "اسم المورد",
      orderType: "نوع الطلب",
      expectedDeliveryDate: "تاريخ التسليم المتوقع",
      totalAmount: "المبلغ الإجمالي",
      status: "الحالة",
      creationDate: "تاريخ الإنشاء",
    },
    create: {
      title: "إنشاء أمر شراء",
      step1Title: "الخطوة 1",
      step1Subtitle: "اختيار المورد",
      step1Description: "اختر المورد الذي تريد الطلب منه",
      step1ProgressTitle: "اختر المورد الذي تريد الطلب منه",
      step2Title: "الخطوة 2",
      step2Subtitle: "إضافة الأصناف",
      step2Description: "أضف الأصناف إلى طلبك",
      step2ProgressTitle: "أضف الأصناف إلى أمر الشراء",
      step3Title: "الخطوة 3",
      step3Subtitle: "تفاصيل الطلب",
      step3Description: "مراجعة وإرسال طلبك",
      step3ProgressTitle: "مراجعة تفاصيل الطلب وإرساله",
      selectSupplier: "اختيار المورد",
      searchSupplier: "بحث",
      supplierDetails: "تفاصيل المورد",
      currency: "العملة",
      contractDetails: "تفاصيل العقد",
      type: "النوع",
      date: "التاريخ",
      submit: "إرسال الطلب",
      noSpecifiedDate: "بدون تاريخ محدد",
      purchaseVariant: "نوع الشراء",
      sideCardDesc1:
        "اذا كان هناك نوع من الشراء محدد، سيتم حفظه لاستخدامه في المستقبل مع هذا المورد.",
      purchasePrice: "سعر الشراء",
      sideCardDesc2:
        "تغيرات في سعر الشراء الموحد سوف يؤثرها على طلبك فقط، حتى واذا كانت الموحدة المحددة كمورد الافتراضي.",
    },
    orderSummary: {
      orderSummary: "ملخص الطلب",
      editItems: "تعديل العناصر",
      paymentSummary: "ملخص الدفع",
      priceBeforeVat: "سعر قبل الضريبة",
      deliveryFees: "رسوم التوصيل",
      grandTotal: "الإجمالي",
      subtotal: "المجموع الفرعي",
      discount: "الخصم",
      vat: "الضريبة",
    },
    additionalDetails: {
      additionalDetails: "تفاصيل اضافية",
      delivery: "التوصيل",
      expectedDeliveryDate: "تاريخ التوصيل المتوقع",
      internalNotes: "ملاحظات داخلية",
      addNotes: "اضافة ملاحظات",
      internalNotesPlaceholder: "اضف ملاحظات داخلية هنا…",
      forSupplier: "للمورد",
      notesInstructions: "ملاحظات وتعليمات",
      supplierNotesPlaceholder: "اضف ملاحظات او تعليمات للمورد هنا…",
      selectOrderType: "حدد نوع الطلب",
      orderTypeHelper: "مساعدة في تجهيز التذاكر وتتبع الطلبات التالية.",
      orderType: "نوع الطلب",
      nextOrderDate: "حدد تاريخ الطلب التالي",
      orderDiscount: "خصم الطلب",
      discountValue: "قيمة الخصم",
      discountPercentage: "نسبة الخصم",
      discountApplied: "تم تطبيق الخصم",
      applyDiscount: "تطبيق الخصم",
      uploadDocument: "رفع المستند",
      chooseFile: "اختر ملف",
      dropFilesHere: "اسحب الملفات هنا",
      formatsHint: "الصيغ المتاحة: PDF، JPG، PNG.",
      invalidFormat: "صيغة غير صالحة. الصيغ المسموح بها: PDF، JPG، PNG.",
      discountMustBeLessThan100: "يجب أن تكون نسبة الخصم أقل من أو تساوي 100",
      discountMustBeGreaterThan0: "يجب أن تكون قيمة الخصم أكبر من 0",
      discountMustBeLessThanSubtotal:
        "يجب أن تكون قيمة الخصم أقل من المجموع الفرعي",
    },
    addItemsModal: {
      title: "إضافة أصناف لأمر الشراء",
      description: "اختر الأصناف التي تريد إضافتها إلى أمر الشراء هذا.",
    },
    addItemsTable: {
      quantity: "الكمية",
      discount: "الخصم",
      subtotal: "المجموع الفرعي",
      noItems: "لم يتم إضافة أي عناصر بعد",
      items: "عناصر",
      value: "قيمة",
      setAsDefault: "تعيين كافتراضي",
      setAsDefaultTooltip:
        "استخدام هذا السعر المُحدّث لأوامر الشراء المستقبلية.",
      clearDefault: "إلغاء الافتراضي",
      clearDefaultTooltip: "تطبيق هذا التغيير في السعر على أمر الشراء هذا فقط.",
      itemsAddedSuccessfully: "تمت إضافة {{count}} عنصر/عناصر بنجاح",
      discountPercentageError: "يجب ألا تتجاوز نسبة الخصم 100٪",
      discountValueError: "يجب ألا تتجاوز قيمة الخصم إجمالي سعر الصنف",
      maxPurchasePriceError: "يجب أن لا يزيد سعر الشراء عن '99999'",
    },
    orderCreated: "تم انشاء الطلب بنجاح",
    orderCreatedDesc: "تم حفظ طلبك وهو جاهز للخطوة التالية.",
    exitTitle: "الخروج بدون حفظ؟",
    exitSubtitle: "يحتوي هذا النموذج على تفاصيل عناصر غير محفوظة.",
    exitDesc: "سيؤدي الخروج الآن إلى حذف جميع البيانات المُدخلة نهائيًا.",
    setAsDefaultTitle:
      "هل أنت متأكد أنك تريد تعيين سعر الشراء {{price}} كسعر افتراضي للعنصر {{item}}؟",
    setAsDefaultDesc:
      "سيتم تطبيق التغييرات في سعر الشراء على جميع أوامر الشراء المستقبلية ما لم يتم تغييره.",
    setAsDefaultCancel: "لا، إلغاء",
    setAsDefaultConfim: "نعم، تعيين كافتراضي",
    clearDefaultTitle:
      "هل أنت متأكد أنك تريد إلغاء السعر الافتراضي وجعل السعر المحدّث للاستخدام لمرة واحدة فقط؟",
    clearDefaultDesc:
      "سيتم تطبيق سعر الشراء المحدّث على هذا الطلب فقط ولن يُستخدم في أوامر الشراء المستقبلية.",
    clearDefaultCancel: "لا، إلغاء",
    clearDefaultConfim: "نعم، إلغاء الافتراضي",
    saveDraftModalTitle: "تم حفظ المسودة!",
    saveDraftModalSubTitle: "تم حفظ تقدمك كمسودة.",
    saveDraftModalDescription:
      "يمكنك العودة لاحقًا لمتابعة تعديل تفاصيل الطلب.",
    saveDraftModalCancel: "الخروج من النموذج",
    saveDraftModalConfirm: "متابعة التعديل",

    draftModalTitle: "لديك أمر شراء غير مكتمل",
    draftModalSubTitle: "لقد بدأت في إنشاء طلب ولكنك لم تُكمله.",
    draftModalDescription: "أكمل المسودة الحالية أو أنشئ طلبًا جديدًا.",
    draftModalCancel: "إنشاء طلب جديد",
    draftModalConfirm: "إكمال النموذج",
    createConfirmationModalTitle: "تأكيد أمر الشراء",
    createConfirmationModalSubTitle:
      "هل أنت متأكد أنك تريد إرسال أمر الشراء هذا؟",
    createConfirmationModalDescription:
      "بمجرد الإرسال، سيتحول أمر الشراء إلى حالة قيد الانتظار وسيصبح متاحًا للاستلام.",
    createConfirmationModalCancel: "لا، متابعة التعديل",
    createConfirmationModalConfirm: "نعم، إرسال الطلب",
    purchaseOrderDetails: "تفاصيل أمر الشراء",
  },

  // Receiving & QC
  receivingQc: {
    title: "الاستلام والجودة",
    startReceiving: "بدء الاستلام",
    receiveOrder: "استلام الطلب",
    noPendingOrders: "لا توجد أوامر شراء معلّقة متاحة للاستلام.",
    noPOMatchYourFilter: "لا توجد أوامر شراء تطابق الفلتر المحدد.",
    overdue: "متأخر",
    deliveryDateFilter: "تصفية تاريخ التسليم",
    creationDateFilter: "تصفية تاريخ الاضافة",
    createOrder: {
      title: "إنشاء أمر استلام",
    },
    stepper: {
      step1Title: "الخطوة ١",
      step1Subtitle: "استلام العناصر",
      step1ProgressTitle: "أدخل الكميات المسلّمة والمقبولة لكل عنصر",
      step2Title: "الخطوة ٢",
      step2Subtitle: "مراجعة وإرسال",
      step2ProgressTitle: "راجع الطلب وأكد الإرسال",
    },
    step1: {
      itemName: "اسم العنصر",
      ordered: "المطلوب",
      delivered: "المسلم",
      accepted: "المقبول",
      rejected: "المرفوض",
      remaining: "المتبقي",
      rejectionReason: "سبب الرفض",
      viewEditReason: "عرض/تعديل السبب",
      all: "الكل",
      partial: "جزئي",
    },
    step2: {
      expectedDeliveryDate: "تاريخ التسليم المتوقع",
      actualDeliveryDate: "تاريخ التسليم الفعلي",
      reviewItems: "مراجعة العناصر",
      paymentSummary: "ملخص الدفع",
      totalAmount: "المبلغ الإجمالي",
    },
    footer: {
      fullyAccepted: "مقبول بالكامل",
      partiallyAccepted: "مقبول جزئياً",
      fullyRejected: "مرفوض بالكامل",
      fullyMissed: "مفقود بالكامل",
      reviewSubmit: "مراجعة وإرسال",
      submit: "إرسال",
      rejectOrder: "رفض الطلب",
    },
    modals: {
      addRejectionReason: "إضافة سبب الرفض",
      editRejectionReason: "تعديل سبب الرفض",
      addRejectionReasonDescription:
        "يرجى تحديد سبب رفض العنصر/العناصر التالية",
      rejectionReasonLabel: "سبب الرفض",
      rejectionReasonPlaceholder: "أضف السبب هنا...",
      uploadDocuments: "رفع المستندات",
      formatsHint: "الصيغ المدعومة: PDF، JPG، PNG.",
      submitReason: "إرسال السبب",
      updateReason: "تحديث السبب",
      rejectOrderTitle: "هل أنت متأكد من رفض هذا الطلب؟",
      rejectOrderSubtitle: "سيؤدي هذا الإجراء إلى رفض الطلب بالكامل.",
      addRejectionReasonLabel: "إذا كانت الإجابة نعم، أضف سبب الرفض",
      yesRejectOrder: "نعم، رفض الطلب",
      orderRejected: "تم رفض الطلب",
      orderRejectedDesc: "تم وضع علامة على جميع العناصر كمرفوضة.",
      confirmSubmitTitle: "تأكيد إرسال الاستلام",
      confirmSubmitDesc:
        "هل أنت متأكد من إرسال نموذج الاستلام هذا؟ بمجرد الإرسال، سيتم تسجيل الكميات المستلمة والمرفوضة وسيتم تحديث أمر الشراء accordingly.",
      keepEditing: "لا، متابعة التعديل",
      confirmReceipt: "نعم، تأكيد الاستلام",
      receivingSuccess: "تم إكمال الاستلام بنجاح",
      receivingSuccessDesc: "تم تحديث حالة أمر الشراء والمخزون.",
    },
    badges: {
      accepted: "مقبول",
      remaining: "متبقي",
      fullyMissed: "مفقود بالكامل",
      fullyRejected: "مرفوض بالكامل",
      rejected: "مرفوض",
    },
  },
  transfers: {
    title: "التحويلات",
    createTransfer: "إنشاء تحويل",
    incomingTransfers: "التحويلات الواردة",
    outgoingTransfers: "التحويلات الصادرة",
    searchPlaceholder: "ابحث برقم التحويل #",
    selectLocation: "اختر الموقع",
    selectStatus: "اختر الحالة",
    total: "الإجمالي: {{count}} تحويل",
    noTransfers: "لا توجد تحويلات بعد",
    noResultsFound: "لا توجد تحويلات تطابق الفلتر المحدد",
    dateFilter: "تصفية تاريخ الإنشاء",
    deliveryDateFilter: "تصفية تاريخ التسليم",
    deliveryDate: {
      filter: "تصفية تاريخ التسليم",
      today: "اليوم",
      yesterday: "أمس",
      customRange: "نطاق مخصص",
    },
    applyMultipleFilters: "قم بتطبيق عدة فلاتر لتضييق نطاق نتائجك.",
    table: {
      totalAmount: "المبلغ الإجمالي",
      transferNumber: "رقم التحويل",
      source: "المصدر",
      destination: "الوجهة",
      createdOn: "تاريخ الإنشاء",
      deliveryDate: "تاريخ التسليم",
      itemCount: "عدد العناصر",
      status: "الحالة",
      actions: "الإجراءات",
    },
    status: {
      pendingReceiving: "قيد الاستلام",
      completed: "مكتمل",
      partiallyAccepted: "مقبول جزئيًا",
      rejected: "مرفوض",
      cancelled: "ملغي",
    },
    details: {
      mainTabs: {
        transferList: "قائمة التحويل",
        infoLog: "معلومات التحويل والسجل",
      },
      actions: {
        cancel: "إلغاء",
        reject: "رفض التحويل",
        startReceiving: "بدء الاستلام",
      },
      transferList: {
        summaryTitle: "ملخص التحويل",
        breakdownTitle: "تفاصيل التحويل",
        itemName: "اسم العنصر",
        transferQty: "كمية التحويل",
        acceptedQty: "الكمية المقبولة",
        totalBaseQty: "إجمالي الكمية الأساسية",
        stockValue: "قيمة المخزون",
        baseAcc: "التكلفة الأساسية",
        transferAmount: "مبلغ التحويل",
        finalStockValue: "قيمة المخزون النهائية",
        finalTransferAmount: "مبلغ التحويل النهائي",
        sent: "المرسل",
        rejected: "المرفوض",
        remaining: "المتبقي",
        status: "الحالة",
        rejectionReason: "سبب الرفض",
        viewReason: "عرض السبب",
        rejectionDetails: "تفاصيل الرفض",
        rejectedItemsCount: "{{count}} مرفوض",
      },
      financial: {
        title: "الملخص المالي",
        itemsCount: "{{count}} عنصر",
        totalStockValue: "إجمالي قيمة المخزون",
        sentValue: "القيمة المرسلة",
        remainingValue: "القيمة المتبقية",
        totalAcceptedValue: "إجمالي القيمة المقبولة",
        totalTransferAmount: "إجمالي مبلغ التحويل",
      },
      tabs: {
        transferInfo: "معلومات التحويل",
        destinationInfo: "معلومات موقع الوجهة",
        activityLog: "سجل النشاط",
      },
      transferInfo: {
        createdOn: "تاريخ الإنشاء",
        createdBy: "أنشئ بواسطة",
        receivedBy: "استلم بواسطة",
        deliveryDate: "تاريخ التسليم",
        transferType: "نوع التحويل",
        statusPending: "قيد الاستلام",
        statusPendingMessage:
          "هذا التحويل بانتظار تأكيد الاستلام من موقع الوجهة.",
        statusCompleted: "مكتمل",
        statusCompletedMessage: "تم استلام هذا التحويل بالكامل وإكماله.",
        statusPartiallyAccepted: "مقبول جزئيًا",
        statusPartiallyAcceptedMessage: "تم استلام وقبول هذا التحويل جزئيًا.",
        statusCancelled: "ملغي",
        statusCancelledMessage: "تم إلغاء هذا التحويل.",
        statusRejected: "مرفوض",
        statusRejectedMessage:
          "تم رفض هذا التحويل ولم تتم الموافقة على معالجته.",
        reasonForRejection: "سبب الرفض:",
      },
      transferTypes: {
        ck_to_branch: "المطبخ المركزي ← الفرع",
        branch_to_branch: "فرع ← فرع",
      },
      destination: {
        title: "الوجهة",
        contactDetails: "بيانات الاتصال",
        phoneNumber: "رقم الهاتف",
        email: "البريد الإلكتروني",
        address: "العنوان",
      },
      cancelModal: {
        title: "إلغاء التحويل",
        message: "هل أنت متأكد من إلغاء هذا التحويل؟",
        warning: "لا يمكن التراجع عن هذا الإجراء.",
        keepTransfer: "الإبقاء على التحويل",
        continueToCancel: "متابعة الإلغاء",
      },
      rejectModal: {
        title: "هل أنت متأكد من رفض هذا التحويل؟",
        message: "سيؤدي هذا الإجراء إلى رفض التحويل بالكامل.",
        reasonLabel: "إذا نعم، أضف سبب الرفض",
        reasonPlaceholder: "أضف السبب هنا..",
        confirm: "نعم، رفض التحويل",
      },
      rejectSuccess: {
        title: "تم رفض التحويل",
        message: "تم تعليم جميع العناصر كمرفوضة.",
      },
    },
  },

  incomingRequests: {
    title: "الطلبات الواردة",
    searchPlaceholder: "ابحث برقم الطلب",
    selectLocation: "اختر الموقع",
    selectCreationDate: "اختر تاريخ الإنشاء",
    locationSelected: "{{location}} محدد",
    total: "الإجمالي: {{count}} طلب",
    noRequestsMatchYourFilter: "لا توجد طلبات تطابق الفلتر المحدد",
    emptyState: {
      title: "لا توجد طلبات مرسلة بعد",
    },
    table: {
      requestNumber: "رقم الطلب",
      requestedBy: "مُرسل من",
      creationDate: "تاريخ الإنشاء",
      itemCount: "عدد العناصر",
      actions: "الإجراءات",
    },
    details: {
      requestInfo: "معلومات الطلب",
      requestedItems: "العناصر المطلوبة",
      itemsCount: "{{count}} عنصر",
      sentOn: "تاريخ الإرسال",
      sentBy: "تم الإرسال بواسطة",
      makeTransfer: "تنفيذ التحويل",
      transfer: "تنفيذ التحويل",
      itemName: "اسم العنصر",
      requestedQty: "الكمية المطلوبة",
      availableStock: "المخزون المتاح",
      availabilityStatus: "حالة التوفر",
      status: {
        pending: "قيد الانتظار",
        pendingMessage: "بانتظار مراجعة المطبخ المركزي وتنفيذ طلب التحويل هذا.",
        pendingReceiving: "قيد الاستلام",
        pendingReceivingMessage:
          "تم إرسال هذا الطلب وهو بانتظار الاستلام في الفرع المستلم.",
        completed: "مكتمل",
        completedMessage: "تم تنفيذ هذا الطلب بالكامل وإغلاقه.",
        partiallyAccepted: "مقبول جزئيًا",
        partiallyAcceptedMessage:
          "تم تنفيذ بعض العناصر بينما لا تزال عناصر أخرى قيد الانتظار.",
      },
    },
    status: {
      available: "متوفر",
      notEnough: "غير كاف",
      outOfStock: "غير متوفر",
    },
    sendItems: {
      pageTitle: "إرسال جميع العناصر إلى الفروع / {{date}}",
      step: {
        title: "الخطوة الأخيرة",
        subtitle: "مراجعة وتأكيد",
        content: "راجع الكميات قبل الإرسال.",
      },
      reviewTitle: "مراجعة الكميات المؤكدة للعناصر",
      scrollHint: "مرّر أفقيًا لعرض جميع الفروع.",
      footer: {
        summary: "{{itemTypes}} أنواع عناصر - {{branches}} فروع",
        sendItems: "إرسال العناصر",
      },
      table: {
        itemNameAndTotals: "اسم العنصر + إجمالي الكميات",
        branchColumn: "{{name}} ({{count}})",
        requested: "المطلوب",
        confirmed: "المؤكد",
        ckStock: "مخزون المطبخ المركزي",
        toPrepare: "للتحضير",
      },
      confirmModal: {
        title: "إرسال العناصر إلى الفروع؟",
        description:
          "سيتم خصم الكميات المرسلة من مخزون المطبخ المركزي، وستُعلَّم العناصر على أنها مُرسَلة إلى الفروع.",
        cancel: "إلغاء",
        confirm: "تأكيد وإرسال",
      },
      successModal: {
        title: "تم إرسال العناصر بنجاح",
        description: "تم إرسال العناصر وتحديث المخزون.",
      },
    },
    startPreparation: {
      pageTitle: "إرسال جميع العناصر إلى الفروع / {{date}}",
      step1: {
        title: "الخطوة 1",
        subtitle: "تحقق من المخزون والكميات",
        content: "تحقق وعدّل كل كمية لضبط كل طلب.",
      },
      step2: {
        title: "الخطوة 2",
        subtitle: "مراجعة وتأكيد",
        content: "أكد الكميات قبل الإرسال.",
      },
      infoCard: {
        title: "التحضير",
        description:
          "سيتم إرسال الكميات الأقل إلى الفروع، وسيتم تحضير المتبقي.",
      },
      checkStockTitle: "تحقق وعدّل كل كمية لضبط كل طلب",
      reviewTitle: "مراجعة كميات التحويل",
      scrollHint: "مرّر أفقيًا لعرض جميع الـ {{count}} فروع.",
      footer: {
        summary: "{{itemTypes}} أنواع عناصر - {{branches}} فروع",
        confirmQuantities: "تأكيد الكميات",
      },
      reviewTable: {
        itemName: "اسم العنصر",
        sku: "رمز SKU",
        requestedQty: "الكمية المطلوبة",
        confirmedQty: "الكمية المؤكدة",
        availableStock: "المخزون المتاح",
        qtyToPrepare: "الكمية للتحضير",
      },
      table: {
        itemNameAndTotals: "اسم العنصر + إجمالي الكميات",
        branchColumn: "{{name}} ({{count}})",
        requested: "المطلوب",
        confirmed: "المؤكد",
        ckStock: "مخزون المطبخ المركزي",
        toPrepare: "للتحضير",
      },
      drawer: {
        title: "تعديل الكميات المؤكدة",
        itemSku: "{{name}} - {{sku}}",
        totalRequested: "إجمالي المطلوب",
        totalConfirmed: "إجمالي المؤكد",
        ckAvailableStock: "مخزون المطبخ المركزي المتاح",
        qtyToPrepare: "الكمية للتحضير",
        requestedQty: "الكمية المطلوبة",
        confirmedQty: "الكمية المؤكدة",
        save: "حفظ الكميات",
        previousItem: "العنصر السابق",
        nextItem: "العنصر التالي",
        qtyUpdated: "تم تحديث الكمية المؤكدة لـ \"{{name}}\"",
        errors: {
          required: "الكمية المؤكدة مطلوبة",
          zeroOrNegative: "لا يمكن أن تكون الكمية سالبة",
          invalid: "أدخل كمية صحيحة",
          exceedsRequested: "لا يمكن أن تتجاوز الكمية المطلوبة",
          tooLong: "لا يمكن أن تتجاوز الكمية 10 أرقام",
          integerOnly: "هذه الوحدة لا تسمح بالكسور",
        },
      },
      confirmModal: {
        title: "تأكيد الكميات لـ {{date}}؟",
        description:
          "سيصبح حالة الطلب «تم التحضير» وستكون ميزة إرسال العناصر متاحة.",
        cancel: "لا، متابعة التعديل",
        confirm: "نعم، تأكيد الكميات",
      },
      readyToSendModal: {
        title: "جميع العناصر جاهزة للإرسال",
        description:
          "يمكنك إرسال الكميات المؤكدة إلى الفروع الآن أو متابعة التعديل.",
        keepEditing: "متابعة التعديل",
        sendItemsNow: "إرسال العناصر الآن",
      },
    },
  },

  // طلبات الأصناف المحضّرة (المطبخ المركزي)
  preparedItemRequests: {
    title: "طلبات الأصناف المحضّرة",
    reviewPreparationPlan: "مراجعة خطة التحضير",
    sendItems: "إرسال العناصر",
    viewAggregatedItems: "عرض العناصر المجمّعة",
    totalRequests: "الإجمالي: {{count}} طلب",
    totalPreparedItems: "الإجمالي: {{count}} صنف محضّر",
    infoTooltip: {
      label: "معلومات حول تواريخ التحضير",
      title: "تجميع تاريخ التحضير",
      description:
        "يُجمّع كل تاريخ تحضير الطلبات المستلمة من المطبخ المركزي قبل موعد القطع. تنتقل الطلبات اللاحقة إلى تاريخ التحضير التالي. اختر تاريخًا لعرض دورته. تصبح مراجعة خطة التحضير متاحة بعد موعد القطع وتُطبَّق على جميع الطلبات في تلك الدورة.",
    },
    tabs: {
      branchRequests: "طلبات الفروع",
      aggregatedItem: "العناصر المجمّعة",
    },
    emptyState: {
      noRequestsSentYet: "لا توجد طلبات مرسلة بعد",
      noResultsFound: "لا توجد نتائج تطابق الفلاتر",
      noItemsForDate: "لا توجد أصناف محضّرة لهذا التاريخ",
      selectPreparationDate: "اختر تاريخ التحضير لعرض العناصر المجمّعة",
      loadError: "تعذّر تحميل طلبات الأصناف المحضّرة. يرجى المحاولة مرة أخرى.",
      retry: "حاول مرة أخرى",
    },
    filters: {
      searchPlaceholder: "ابحث برقم الطلب أو الفرع أو الصنف المحضّر",
      aggregatedSearchPlaceholder: "ابحث باسم الصنف المحضّر أو SKU",
      selectSubmissionDate: "اختر تاريخ التقديم",
      selectPreparationDate: "اختر تاريخ التحضير",
      preparationPlanDate: "تاريخ خطة التحضير",
      selectRequestingBranch: "اختر الفرع الطالب",
      branchSelected: "{{branch}} محدد",
      requestStatusAll: "حالة الطلب: الكل",
      requestStatusWithValue: "حالة الطلب: {{status}}",
      statusAll: "الحالة: الكل",
      statusPending: "قيد الانتظار",
      statusCompleted: "مكتمل",
    },
    table: {
      requestNumber: "رقم الطلب",
      requestedBy: "مقدَّم من",
      submissionDate: "تاريخ التقديم",
      preparationDate: "تاريخ التحضير",
      preparedItems: "الأصناف المحضّرة",
      totalAmount: "المبلغ الإجمالي",
      requestStatus: "حالة الطلب",
      actions: "الإجراءات",
    },
    aggregatedTable: {
      preparedItemName: "اسم الصنف المحضّر",
      sku: "رمز التخزين",
      totalRequestedQty: "إجمالي الكمية المطلوبة",
      totalConfirmedQty: "إجمالي الكمية المؤكدة",
      ckAvailableStock: "المخزون المتاح في المطبخ المركزي",
      qtyToPrepare: "الكمية للتحضير",
      requestingBranches: "الفروع الطالبة",
    },
    plans: {
      title: "خطط التحضير",
      subtitle: "اختر يوم تحضير لعرض طلباته المعلقة.",
      todaysPlan: "خطة اليوم",
      todaysPlanDescription: "الطلبات المعلقة المخصصة لليوم",
      nextPreparation: "التحضير القادم",
      nextPreparationDescription: "الطلبات المقدمة بعد موعد قطع اليوم",
      allRequests: "جميع الطلبات",
      allRequestsDescription: "عرض جميع الطلبات بغض النظر عن تاريخ التحضير.",
      requestCountLabel: "طلبات",
    },
    summary: {
      todaysPreparation: "تحضير اليوم",
      nextPreparation: "التحضير القادم",
      allRequests: "جميع الطلبات",
      requestsInPlan: "الطلبات في الخطة",
      branches: "{{count}} فروع",
      preparationDate: "تاريخ التحضير",
      requestCutoff: "موعد قطع الطلبات",
      timeLeft: "{{time}} متبقي",
      preparationStatus: "حالة التحضير",
      totalPreparedItems: "إجمالي الأصناف المحضّرة",
      items: "أصناف",
      allRequestsDescription: "عرض جميع الطلبات بغض النظر عن تاريخ التحضير.",
    },
    status: {
      pending: "قيد الانتظار",
      awaitingReview: "بانتظار المراجعة",
      beingPrepared: "قيد التحضير",
      prepared: "جاهز",
      sent: "تم الإرسال",
      completed: "مكتمل",
      completedClosedShort: "مكتمل (مغلق بنقص)",
      rejected: "مرفوض",
    },
    details: {
      title: "تفاصيل الطلب",
      aggregatedTitle: "تفاصيل العناصر المجمّعة",
      requestInfo: "معلومات الطلب",
      preparationInfo: "معلومات التحضير",
      requestedItems: "الأصناف المطلوبة",
      itemTypes: "{{count}} نوع صنف",
      itemsCount: "{{count}} عناصر",
      totalRequests: "إجمالي الطلبات",
      requestingBranches: "الفروع الطالبة",
      requestsCount: "{{count}} طلبات",
      sentStatusMessage:
        "اكتمل الإرسال. تم خصم الكميات المرسلة من مخزون المطبخ المركزي.",
      preparedItemName: "اسم الصنف المحضر",
      requestedQty: "الكمية المطلوبة",
      requestedAmount: "المبلغ المطلوب",
      confirmedQty: "الكمية المؤكدة",
      confirmedAmount: "المبلغ المؤكد",
      sentQty: "الكمية المرسلة",
      sentAmount: "المبلغ المرسل",
      createdOn: "تاريخ الإنشاء",
      submittedOn: "تاريخ التقديم",
      createdBy: "أنشئ بواسطة",
      preparationStatus: "حالة التحضير",
      preparationStartedOn: "بدء التحضير في",
      preparationStartedBy: "بدء التحضير بواسطة",
      confirmQuantitiesOn: "تأكيد الكميات في",
      confirmQuantitiesBy: "تأكيد الكميات بواسطة",
      markedPreparedOn: "تم التحضير في",
      markedPreparedBy: "تم التحضير بواسطة",
      sentOn: "تاريخ الإرسال",
      sentBy: "أُرسل بواسطة",
      rejectedOn: "تاريخ الرفض",
      rejectedBy: "رُفض بواسطة",
      reasonForRejection: "سبب الرفض",
      financialSummary: "الملخص المالي",
      totalRequestedValue: "إجمالي القيمة المطلوبة",
      shortValue: "القيمة الناقصة",
      totalSentAmount: "إجمالي المبلغ المرسل",
      totalReceivedAmount: "إجمالي المستلم",
      reject: "رفض",
      requestingBranch: "الفرع الطالب",
      rejectModal: {
        title: "هل أنت متأكد من رفض هذا الطلب؟",
        message: "سيؤدي هذا الإجراء إلى رفض الطلب بالكامل.",
        reasonLabel: "إذا نعم، أضف سبب الرفض",
        reasonPlaceholder: "أضف السبب هنا...",
        confirm: "نعم، رفض الطلب",
      },
    },
    planNotice: {
      todayClosedBold: "خطة اليوم مغلقة أمام الطلبات الجديدة.",
      todayOpenBold: "خطة اليوم مفتوحة لاستقبال الطلبات الجديدة.",
      todayClosedDetail:
        "الطلبات المقدمة بعد {{time}} ستُدرَج في تاريخ التحضير التالي.",
      nextScheduledBold: "هذه الطلبات مجدولة لـ {{date}}.",
      nextScheduledDetail: "لا تُدرَج في خطة تحضير اليوم.",
    },
    banner: {
      preparationActionsApply:
        "تُطبَّق إجراءات التحضير على جميع طلبات {{date}}، بما فيها الطلبات المفلترة.",
    },
  },


  requestsSent: {
    title: "طلبات العناصر المحضرة",
    createRequest: "إنشاء طلب",
    emptyState: {
      title: "لا توجد طلبات بعد",
    },
    total: "الإجمالي: {{count}} طلب",
    itemsCount: "{{count}} عناصر",
    datePlaceholder: "DD/MM/YYYY",
    selectStatus: "اختر الحالة",
    statusSelected: "الحالة: {{status}}",
    searchPlaceholder: "ابحث برقم الطلب",
    selectCreationDate: "اختر تاريخ الإنشاء",
    table: {
      requestNumber: "رقم الطلب",
      creationDate: "تاريخ الإنشاء",
      preparedItems: "العناصر المحضرة",
      preparationDate: "تاريخ التحضير",
      totalAmount: "المبلغ الإجمالي",
      status: "الحالة",
      actions: "الإجراءات",
    },
    details: {
      title: "تفاصيل الطلب",
      requestInfo: "معلومات الطلب",
      requestedItems: "الأصناف المطلوبة",
      itemTypes: "{{count}} نوع صنف",
      preparedItemName: "اسم الصنف المحضر",
      requestedQty: "الكمية المطلوبة",
      requestedAmount: "المبلغ المطلوب",
      receivedQty: "الكمية المستلمة",
      receivedAmount: "المبلغ المستلم",
      shortQty: "الكمية الناقصة",
      shortAmount: "المبلغ الناقص",
      createdOn: "تاريخ الإنشاء",
      createdBy: "أنشئ بواسطة",
      receivedOn: "تاريخ الاستلام",
      receivedOnHint:
        "تاريخ الاستلام يوضح متى أنهى المطبخ المركزي إرسال الأصناف. ولا يؤكد الاستلام الفعلي في فرعك.",
      editedOn: "تاريخ التعديل",
      editedBy: "عُدّل بواسطة",
      rejectedOn: "تاريخ الرفض",
      rejectedBy: "رُفض بواسطة",
      rejectReason: "سبب الرفض",
      cancelledOn: "تاريخ الإلغاء",
      cancelledBy: "أُلغي بواسطة",
      cancelModal: {
        title: "إلغاء الطلب؟",
        message: "سيؤدي إلغاء هذا الطلب إلى إيقافه عن المتابعة إلى التحضير.",
        warning: "لا يمكن التراجع عن هذا الإجراء.",
        keepRequest: "الاحتفاظ بالطلب",
        continueToCancel: "المتابعة للإلغاء",
      },
      financialSummary: "الملخص المالي",
      totalRequestedValue: "إجمالي القيمة المطلوبة",
      shortValue: "القيمة الناقصة",
      vat: "ضريبة القيمة المضافة",
      totalReceivedAmount: "الإجمالي المستلم",
      timeWindowClosed: "انتهت النافذة الزمنية",
      timeWindowCloses: "النافذة الزمنية تغلق خلال",
      timeLeftToEditCancel: "الوقت المتبقي للتعديل/الإلغاء",
    },
  },

  createPreparedRequest: {
    title: "طلب عنصر محضّر",
    editTitle: "تعديل طلب العناصر المحضّرة",
    step1Title: "الخطوة 1",
    step1Subtitle: "إضافة العناصر",
    step1Content: "إضافة العناصر التي تريد طلبها.",
    step2Title: "الخطوة 2",
    step2Subtitle: "مراجعة وتأكيد",
    step2Content: "راجع جميع الإدخالات وأكد إرسال الطلب.",
    step1SectionTitle: "إضافة الكميات المطلوبة",
    step2SectionTitle: "مراجعة طلب العناصر المحضّرة",
    addPreparedItems: "إضافة عناصر محضّرة",
    addItemsModal: {
      title: "إضافة عناصر محضّرة إلى الطلب",
      description: "اختر عناصر من فئة واحدة أو أكثر.",
    },
    emptyState: {
      title: "لم تُضف عناصر بعد",
    },
    table: {
      itemName: "اسم العنصر",
      sku: "SKU",
      availableStock: "المخزون المتاح",
      enteredQty: "الكمية المدخلة",
      actions: "الإجراءات",
      qtyPlaceholder: "أضف الكمية المطلوبة",
    },
    qtyErrors: {
      required: "الكمية مطلوبة",
      zeroOrNegative: "يجب أن تكون الكمية أكبر من صفر",
      invalid: "كمية غير صالحة",
    },
    review: {
      outputUom: "وحدة قياس المخرج",
      requestedQty: "الكمية المطلوبة",
    },
    footer: {
      itemTypesAdded: "تمت إضافة {{count}} أنواع عناصر",
      submit: "طلب عنصر محضّر",
      update: "حفظ التغييرات",
    },
    confirmModal: {
      title: "إرسال الطلب؟",
      description:
        "سيتم إرسال طلبك إلى المطبخ المركزي. لن يتم تطبيق أي حركة مخزون في هذه المرحلة.",
      cancel: "إلغاء",
      confirm: "إرسال الطلب",
    },
    editConfirmModal: {
      title: "تحديث الطلب؟",
      description:
        "سيتم إرسال الكميات المحدّثة إلى المطبخ المركزي. لن يتم تطبيق أي حركة مخزون في هذه المرحلة.",
      confirm: "تحديث الطلب",
    },
    successModal: {
      title: "تم إرسال الطلب بنجاح",
      description:
        "تم إرسال طلبك إلى المطبخ المركزي. لم يتم تطبيق أي حركة مخزون في هذه المرحلة.",
      backToDashboard: "العودة إلى لوحة التحكم",
      viewRequest: "عرض الطلب",
    },
  },
  //inventory
  inventory: {
    itemStockDetails: "تفاصيل المخزون",
    setOpenningBalance: "تحديد الرصيد الافتتاحي",
    totalStockValue: "قيمة المخزون الإجمالية",
    liveInventory: "المخزون المباشر",
    viewOpeningBalance: "عرض الرصيد الافتتاحي",
    totalItems: "إجمالي العناصر",
    totalItemsCount: "الإجمالي: {{count}} عنصر",
    acrossAllCategories: "عبر جميع الفئات",
    aboveLevel: "أعلى من المستوى",
    atLevel: "عند المستوى",
    belowLevel: "أقل من المستوى",
    outOfStock: "نفد المخزون",
    itemsReorderNeeded: "عناصر (تتطلب إعادة طلب)",
    searchPlaceholder: "ابحث بالاسم، رمز التخزين، ...",
    selectCategory: "اختر الفئة",
    selectSubcategory: "اختر الفئة الفرعية",
    categorySelected: "{{category}} — محدد",
    subcategorySelectedSingle: "{{count}} فئة فرعية محددة",
    subcategorySelectedMultiple: "{{count}} فئات فرعية محددة",
    export: {
      itemName: "اسم الصنف",
      sku: "رمز التخزين",
      category: "الفئة",
      subcategory: "الفئة الفرعية",
      currentQty: "الكمية الحالية",
      baseUnit: "الوحدة الأساسية",
      baseAcc: "متوسط التكلفة",
      stockValue: "قيمة المخزون",
      lastMovementDate: "تاريخ آخر حركة",
      lastMovementType: "نوع آخر حركة",
      lastMovementQty: "كمية آخر حركة",
      parLevel: "مستوى الحد الأدنى",
      barLevelStatus: "حالة مستوى الشريط",
    },
    sortBy: "ترتيب حسب",
    sortItemNameAsc: "اسم العنصر (أ-ي)",
    sortItemNameDesc: "اسم العنصر (ي-أ)",
    sortQtyAsc: "الكمية الحالية (من الأقل للأعلى)",
    sortQtyDesc: "الكمية الحالية (من الأعلى للأقل)",
    sortValueAsc: "قيمة المخزون (من الأقل للأعلى)",
    sortValueDesc: "قيمة المخزون (من الأعلى للأقل)",
    sortLastMovementAsc: "آخر حركة (الأقدم)",
    sortLastMovementDesc: "آخر حركة (الأحدث)",
    itemName: "اسم العنصر",
    currentQty: "الكمية الحالية (الوحدة الأساسية)",
    baseAcc: "متوسط التكلفة",
    stockValue: "قيمة المخزون",
    lastMovementDate: "تاريخ آخر حركة",
    parLevel: "مستوى الحد الأدنى",
    barLevelStatus: "حالة مستوى الشريط",
    emptyTitle: "لا توجد بيانات مخزون بعد",
    emptyDescription:
      "ابدأ بتسجيل الرصيد الافتتاحي. هذه الخطوة لمرة واحدة لتحديد الكميات الحالية وتكاليفها.",
    noResultsTitle: "لا توجد نتائج",
    noResultsDescription: "حاول تعديل البحث أو الفلاتر.",
    openingBalanceTitle: "الرصيد الافتتاحي",
    reviewStockDetails: "مراجعة تفاصيل المخزون",
    exportOpeningBalancePdf: "تصدير PDF",
    obEnteredBaseQty: "الكمية الأساسية المدخلة",
    obUnitCost: "تكلفة الوحدة",
    obColPurchaseUomPack: "وحدة الشراء / حجم العبوة",
    obColEnteredQty: "الكمية المدخلة",
    obColPurchaseCost: "تكلفة الشراء",
    obColTotalBaseQty: "إجمالي الكمية الأساسية",
    obColBaseUnitCost: "تكلفة الوحدة الأساسية",
    stockSummary: "ملخص المخزون",
    expandAll: "توسيع الكل",
    collapseAll: "طي الكل",
    baseUnitEntry: "حسب الوحدة الأساسية",
    purchaseUnitEntry: "حسب وحدة الشراء",
    lastMovement: "آخر حركة",
    lastMovementWasGain: "كانت آخر حركة زيادة",
    lastMovementWasReduction: "كانت آخر حركة خفضًا",
    receiving: "استلام",
    transferToBranch: "تحويل إلى الفرع",
    change: "التغير",
    currency: "درهم",
    items: "عناصر",
    movementHistory: "تاريخ الحركة",
    currentStock: "المخزون الحالي",
    avgCurrentCost: "متوسط التكلفة الحالية (ACC)",
    kilogramsUnit: "كيلوغرامات ({{unit}})",
    last7Days: "آخر 7 أيام",
    last30Days: "آخر 30 يومًا",
    selectMovementType: "اختر نوع الحركة",
    gain: "+ زيادة",
    reduction: "- نقص",
    positiveAdjustment: "تسوية إيجابية",
    negativeAdjustment: "تسوية سلبية",
    batchOutput: "إخراج دفعة",
    batchInput: "إدخال دفعة",
    itemStockDetailsTable: {
      totalMovements: "الإجمالي: {{count}} حركة",
      movementDate: "تاريخ الحركة",
      type: "النوع",
      quantityImpact: "تأثير الكمية",
      resultedBalance: "الرصيد الناتج",
      accAtMoment: "متوسط التكلفة وقت الحركة",
      reason: "السبب",
      reasonDetailsTitle: "تفاصيل السبب",
    },
    create: {
      title: "الرصيد الافتتاحي",
      step1Title: "الخطوة 1",
      step1Subtitle: "تحديد المخزون الافتتاحي",
      step1Content: "أضف الكميات والتكاليف لتحديد المخزون الأولي",
      step2Title: "الخطوة 2",
      step2Subtitle: "مراجعة وتأكيد",
      review_submit: "مراجعة وإرسال",
      totalStockValue: "إجمالي قيمة المخزون",
      itemsAdded: "إجمالي العناصر",
      selectItem: "اختر العنصر",
      categoryFilter: "تصفية حسب الفئة",
      searchPlaceholder: "بحث عن عناصر أو رمز SKU",
      table: {
        itemName: "اسم العنصر",
        sku: "رمز SKU",
        totalQty: "إجمالي الكمية",
        baseACC: "تكلفة الوحدة الأساسية",
        openingStockValue: "قيمة المخزون الافتتاحي",
        purchaseUnits: "وحدات الشراء",
        viewEdit: "عرض / تعديل",
      },
      sidePanel: {
        setOpeningStock: "تحديد المخزون الافتتاحي",
        resetAll: "إعادة تعيين الكل",
        looseBaseQuantity: "الكمية الأساسية / المفردة",
        purchaseUnitEntry: "إدخال وحدة الشراء",
        stockBoughtOrStoredInBaseUnitDirectly:
          "تم شراء أو تخزين المخزون بوحدة {{baseUOM}} مباشرةً.",
        PurchaseUnitsQuantity: "كمية وحدات الشراء",
        stockBoughtOrStoredInPurchaseUnitDirectly:
          "تم استلام وعدّ المخزون بوحدة الشراء.",
        AddAnotherPurchaseUnit: "إضافة وحدة شراء أخرى",
        NoMorePurchaseUnitsAvailable: "لا توجد وحدات شراء أخرى متاحة",
        cancel: "إلغاء",
        saveItem: "حفظ العنصر",
        resetAllWarning: "إعادة تعيين جميع المدخلات؟",
        resetAllWarningsubTitle:
          "سيتم مسح جميع الكميات والتكاليف المُدخلة للعناصر المحددة.",
        resetAllWarningDesc: "لا يمكن التراجع عن هذا الإجراء.",
        resetAllWarningCancel: "إلغاء",
        resetAllWarningReset: "إعادة تعيين الكل",
        quantity: "الكمية",
        unitCost: "تكلفة الوحدة",
        purchaseCost: "تكلفة الشراء",
        resetEntriesSuccessfullyTitle: "تم مسح البيانات بنجاح",
        resetEntriesSuccessfullyDesc:
          "تمت إعادة تعيين النموذج وهو جاهز لإدخال بيانات جديدة.",
        quantityTooLong: "الكمية لا يمكن أن تتجاوز 10 أرقام",
        unitCostGreaterThanZero: "تكلفة الوحدة يجب أن تكون أكبر من 0",
        purchaseCostGreaterThanZero: "تكلفة الشراء يجب أن تكون أكبر من 0",
        quantityGreaterThanZero: "الكمية يجب أن تكون أكبر من 0",
      },
    },
    confirmCreationModal: {
      title: "تأكيد المخزون الافتتاحي",
      subTitle: "هل أنت متأكد أنك تريد إرسال الرصيد الافتتاحي؟",
      description:
        "بمجرد الإرسال، سيتم استخدام الكميات المُدخلة لتهيئة المخزون لهذه الأصناف. سيتم احتساب متوسط التكلفة الحالية الأولية (ACC) وسيصبح الصنف نشطًا في تتبع المخزون.",
      cancel: "لا، الاستمرار في التعديل",
      confirm: "تأكيد وتهيئة المخزون",
    },
    createSuccessModal: {
      title: "تم إعداد المخزون الافتتاحي بنجاح",
      description: "تم تفعيل تتبع المخزون الآن.",
    },
    exitWithoutSavingModal: {
      title: "الخروج بدون حفظ؟",
      subTitle: "يحتوي هذا النموذج على بيانات غير محفوظة.",
      description:
        "الخروج الآن سيؤدي إلى حذف جميع البيانات المُدخلة بشكل نهائي.",
      cancel: "تجاهل والخروج",
      confirm: "حفظ كمسودة",
    },
    saveDraftModal: {
      title: "تم حفظ المسودة!",
      subTitle: "تم حفظ تقدمك كمسودة.",
      description: "يمكنك العودة لاحقًا لمتابعة تعديل الرصيد الافتتاحي.",
      cancel: "الخروج من النموذج",
      confirm: "متابعة التعديل",
    },
    completeDraftModal: {
      title: "لديك رصيد افتتاحي غير مكتمل",
      subTitle: "لقد بدأت إدخال الرصيد الافتتاحي ولكنك لم تُكمله.",
      description: "قم بإكمال المسودة الحالية أو ابدأ واحدة جديدة.",
      cancel: "تعيين رصيد افتتاحي جديد",
      confirm: "إكمال النموذج",
    },
    stockDetails: {
      consumptionByType: "الاستهلاك حسب النوع",
      sinceOpeningBalance: "منذ الرصيد الافتتاحي",
      allTime: "كل الوقت",
      totalConsumed: "إجمالي المستهلك",
      days: "أيام",
      movements: "الحركات",
      SinceOpeningBalance: "منذ الرصيد الافتتاحي",
      batchInput: "إدخال دفعة",
      transferToBranch: "تحويل إلى فرع",
      negativeAdjustment: "تسوية سالبة",
      totalStockAdded: "إجمالي المخزون المضاف",
      totalStockAddedSubtitle:
        "جميع المخزون المستلم والمضاف منذ الرصيد الافتتاحي",
      totalQtyAdded: "إجمالي الكمية المضافة",
      bySupplier: "حسب المورد",
      otherAdditions: "إضافات أخرى",
      positiveAdjustments: "تسويات موجبة",
      openingBalance: "الرصيد الافتتاحي",
      purchaseUomPackSize: "وحدة الشراء / حجم العبوة",
      totalQty: "إجمالي الكمية",
      footnote:
        "*النسبة والكمية تُظهران حصة إجمالي الكمية المُدخلة لكل مورد، بناءً على جميع سجل الحركات منذ الرصيد الافتتاحي.",
    },
  },

  //receive transfer
  receiveTransfer: {
    create: {
      title: "استلام تحويل",
      step1Title: "الخطوة 1",
      step1Subtitle: "استلام العناصر",
      step1Content:
        "أضف الكميات المستلمة وقم بتسجيل أي عناصر مفقودة أو مرفوضة.",
      step2Title: "الخطوة 2",
      step2Subtitle: "مراجعة وتأكيد",
      step2Content:
        "مراجعة جميع المدخلات، أضف تاريخ التسليم، وتأكيد التحديث لتحديث المخزون.",
      step1: {
        itemName: "اسم العنصر",
        sent: "مرسل",
        delivered: "مستلم",
        accepted: "مقبول",
        rejected: "مرفوض",
        missing: "مفقود",
        remaining: "متبقي",
        rejectionReason: "سبب الرفض",
      },
      step2: {
        createdOn: "تاريخ الإنشاء",
        actualDeliveryDate: "تاريخ التسليم الفعلي",
        reviewItems: "مراجعة العناصر",
        financialSummary: "الملخص المالي",
        sentValue: "القيمة المرسلة",
        remainingValue: "القيمة المتبقية",
        acceptedValue: "القيمة المقبولة",
        inventoryUpdate: {
          title: "تحديث المخزون",
          description:
            "سيتم إضافة الكميات المقبولة فقط إلى مخزون الجهة المستلمة. الكميات المفقودة أو المرفوضة سيتم تسجيلها ككمية متبقية.",
        },
        badges: {
          accepted: "مقبول",
          remaining: "متبقي",
          fullyMissed: "مفقود بالكامل",
          fullyRejected: "مرفوض بالكامل",
        },
      },
      footer: {
        fullyAccepted: "مقبول بالكامل",
        partiallyAccepted: "مقبول جزئياً",
        fullyMissed: "مفقود بالكامل",
        fullyRejected: "مرفوض بالكامل",
        itemTypes: "أنواع العناصر",
        acceptedAmount: "المبلغ المقبول",
        remaining: "المتبقي",
      },
      confirmModal: {
        title: "إرسال استلام؟",
        description:
          "سيتم إضافة الكميات المقبولة إلى المخزون الموجه. لن يتم إدخال الكميات المفقودة أو المرفوضة إلى المخزون.",
        cancel: "لا ، الاستمرار في التعديل",
        confirm: "نعم ، إرسال الاستلام",
      },
      fullyAcceptedSuccessModal: {
        title: "تم استلام التحويل بالكامل",
        description: "تم استلام التحويل بالكامل. تم تحديث المخزون الموجه.",
      },
      partiallyAcceptedSuccessModal: {
        title: "تم استلام التحويل جزئياً",
        description: "تم استلام التحويل جزئياً. تم تسجيل التغييرات.",
      },
    },
  },
  // create transfer branch
  createTransferBranch: {
    title: "إنشاء تحويل",
    step1Title: "الخطوة 1",
    step1Subtitle: "إضافة العناصر",
    step1Content: "أضف العناصر التي تريد تحويلها.",
    step2Title: "الخطوة 2",
    step2Subtitle: "مراجعة وتأكيد",
    step2Content: "مراجعة جميع المدخلات وتأكيد الإرسال.",
    addItemsHeader: {
      title: "إضافة الكميات المطلوبة",
    },
    addItemsTable: {
      availableStock: "المخزون المتاح",
      transferQty: "الكمية المحولة",
      totalBaseQty: "إجمالي الكمية الأساسية",
      purchaseUomPackSize: "وحدة الشراء / حجم العبوة",
      loosePackSize: "مفرد / {{packSize}}",
      transferQtyPlaceholder: "أضف الكمية المحولة",
      transferQtyRequired: "الكمية المحولة مطلوبة",
      transferQtyGreaterThanZero: "الكمية المحولة يجب أن تكون أكبر من 0",
      transferQtyLessThanStock: "الكمية المحولة تتجاوز المخزون المتاح",
      noItems: "لا يوجد عناصر مضافة بعد",
      transferAmount: "مبلغ التحويل",
    },
    addItemsModal: {
      title: "إضافة العناصر إلى الطلب",
      description: "اختر العناصر من فئة واحدة أو أكثر.",
      selectType: "اختر النوع",
    },
    step2: {
      selectDestinationLocation: "اختيار موقع الفرع المستلم",
      selectBranchPlaceholder: "اختر الفرع",
      reviewTransferDetails: "مراجعة تفاصيل التحويل",
      totalBaseQty: "إجمالي اكمية الأساسية",
      purchaseUomPackSize: "وحدة الشراء / حجم العبوة",
      expandAll: "توسيع الكل",
      collapseAll: "طي الكل",
      stockUpdate: "تحديث المخزون",
      stockUpdateDescription:
        "سيتم خصم الكميات من مخزون الجهة المصدرة بعد تأكيد الإرسال. وسيتم إضافة الكميات إلى مخزون الجهة المستلمة فقط عند تأكيد الاستلام.",
    },
    footer: {
      itemsAdded: "الأنواع المضافة",
      submit: "إرسال التحويل",
      totalTransferAmount: "مبلغ التحويل الإجمالي",
    },
    confirmModal: {
      title: "إرسال التحويل",
      subTitle: "هل أنت متأكد أنك تريد إرسال هذا التحويل؟",
      description:
        "بمجرد الإرسال، سيتم خصم الكميات من مخزون الجهة المصدرة. سيتم إضافة الكميات فقط إلى مخزون الجهة المستلمة بعد التأكيد على الاستلام.",
      cancel: "لا ، الاستمرار في التعديل",
      confirm: "نعم ، إرسال التحويل",
    },
    successModal: {
      title: "تم إرسال التحويل بنجاح",
      description: "تم إرسال التحويل وتم تحديث مخزونك.",
    },
  },

  // Prepared Items
  preparedItems: {
    title: "العناصر المُحضّرة",
    import: {
      importItems: "استيراد العناصر المُحضّرة",
      importItemsSubtitle:
        "قم برفع مستند معبأ لإضافة عناصر مُحضّرة متعددة دفعة واحدة.",
      importItemsDescription:
        "استخدم هذا القالب للتأكد من تنسيق العناصر المُحضّرة بشكل صحيح قبل الرفع.",
      validationErrors: {
        outputUOMRequired: "وحدة قياس الإنتاج مطلوبة",
        invalidOutputUOM: "وحدة قياس الإنتاج غير صالحة.",
        storageConditionRequired: "ظروف التخزين مطلوبة",
        invalidStorageCondition: "ظروف التخزين غير صالحة.",
        canUseRecipesRequired: "حقل يمكن استخدامه في الوصفات مطلوب",
        invalidYesNo: "يجب أن تكون القيمة yes أو no",
      },
    },
    storageCondition: "ظروف التخزين",
    outputUom: "وحدة قياس الإنتاج",
    dateFilter: "تاريخ التصنيع",
    estQty: "الكمية المقدرة",
    ingredients: "المكونات",
    ingredientQty: "كمية المكون",
    lastUpdatedDate: "تاريخ آخر تحديث",
    recipe: "الوصفة",
    recipeItems: "{{count}} عناصر",
    noItems: "لا يوجد عناصر مضافة بعد",
    latestFirst: "الأحدث أولاً",
    default: "الافتراضي",
    oldestFirst: "الأقدم أولاً",
    details: {
      itemDetails: "تفاصيل العنصر",
      startBatch: "بدء الدفعة",
      finishSetup: "إكمال الإعداد",
      outputUom: "وحدة قياس الإنتاج",
      outputUomDescription: "الوحدة التي يُنتَج بها العنصر المُحضّر.",
      canBeUsedInRecipes: "يمكن استخدامه في الوصفات",
      statusActiveDescription:
        "هذا العنصر نشط ومتاح للاستخدام والاختيار في النظام.",
      statusInactiveDescription:
        "هذا العنصر غير نشط وغير متاح للاستخدام في النظام.",
      financialSummary: "الملخص المالي",
      totalEstIngredientsCost: "إجمالي تكلفة المكونات المقدرة",
      estCostPerOutputUom: "التكلفة المقدرة / وحدة الإنتاج",
      notesAndInstructions: "الملاحظات والتعليمات",
      defaultPrepTime: "وقت التحضير الافتراضي",
      preparationInstructions: "تعليمات التحضير",
      qualityNotes: "ملاحظات الجودة",
      attachments: "المرفقات / الصور",
      noIngredientsTitle: "لم تُضف مكونات بعد",
      noIngredientsDescription: "تُضاف المكونات أثناء إعداد التحضير.",
      noPrepDetailsTitle: "لا توجد تفاصيل تحضير بعد",
      noPrepDetailsDescription:
        "ستظهر تعليمات التحضير وملاحظات الجودة ووقت التحضير هنا بعد اكتمال الإعداد.",
      noNotesOrInstructionsTitle: "لم تُضف ملاحظات أو تعليمات",
      viewNotes: "عرض ملاحظات المكون",
      ingredientNotes: "ملاحظات المكون",
      tabs: {
        detailsAndIngredients: "التفاصيل والمكونات",
        notesAndActivity: "الملاحظات وسجل النشاط",
      },
      table: {
        itemName: "اسم العنصر",
        baseUnit: "الوحدة الأساسية",
        quantity: "الكمية",
        currentAcc: "متوسط التكلفة الحالي",
        estIngredientCost: "تكلفة المكون المقدرة",
        notes: "ملاحظات",
      },
    },
    finishSetup: {
      title: "إعداد التحضير",
      submitSetup: "إرسال الإعداد",
      setupCard: {
        itemsNeedSetup: "{{count}} عناصر تحتاج إلى إعداد",
        setUpAll: "إعداد الكل",
      },
      step1: {
        title: "الخطوة 1",
        description: "المكونات.",
        content: "اختر عنصراً وأضف مكوناته.",
        sectionTitle: "اختر العنصر المُحضّر",
        sectionSubtitle: "اختر عنصراً مُحضّراً وأضف المكونات المطلوبة للتحضير.",
        searchPlaceholder: "ابحث بالاسم أو SKU",
        ingredientsCount: "عدد المكونات",
        addIngredients: "إضافة مكونات",
        noIngredientsAdded: "لم تُضف مكونات بعد",
        viewEditNotes: "عرض / تعديل",
        addNotes: "إضافة ملاحظات",
        addItemsModal: {
          title: "إضافة مكونات للعناصر المُحضّرة",
          description:
            "اختر عناصر من فئة واحدة أو أكثر لتحديد كمية المكونات والملاحظات.",
        },
        notesDrawer: {
          title: "إضافة ملاحظات",
          description: "ملاحظات اختيارية حول التداول أو التحضير لهذا المكون.",
          placeholder: "أدخل ملاحظات التداول أو التحضير...",
          characters: "حرف",
          submit: "إرسال الملاحظات",
        },
      },
      step2: {
        title: "الخطوة 2",
        description: "الإنتاج والتحضير.",
        content: "حدّد كمية الإنتاج وتعليمات التحضير.",
        sectionTitle: "تحديد كمية الإنتاج وتعليمات التحضير",
        sectionSubtitle:
          "أدخل كمية الإنتاج المقدرة وأضف تعليمات التحضير لكل عنصر.",
        outputName: "اسم الإنتاج",
        estimatedQuantity: "الكمية المقدرة",
        prepInstructions: "تعليمات التحضير",
        addPrep: "إضافة تعليمات التحضير",
        viewEditPrep: "عرض / تعديل",
        noItems: "لا توجد عناصر بمكونات محفوظة بعد.",
        prepModal: {
          title: " تعليمات التحضير",
          submit: "إرسال التعليمات",
          defaultPrepTimeDescription: "وقت التحضير الافتراضي لهذا العنصر.",
          preparationSteps: "خطوات التحضير",
          prepStepsPlaceholder: "أدخل خطوات التحضير...",
          qualityNotesPlaceholder: "أدخل ملاحظات الجودة أو الفحوصات...",
          dropzoneText: "أسقط الصور أو ملفات PDF هنا للرفع",
          attachmentsHint: "يُدعم رفع الصور وملفات PDF.",
        },
      },
      step3: {
        title: "الخطوة 3",
        description: "المراجعة والإرسال.",
        content: "راجع جميع العناصر وأرسل.",
        sectionTitle: "مراجعة إعداد التحضير",
        totalQuantity: "إجمالي الكمية",
        noItems: "لا توجد عناصر جاهزة للإرسال بعد.",
        ingredientsWithCount: "المكونات ({{count}})",
        ingredientsSummary: "المكونات",
        prepDetails: "تفاصيل التحضير",
        defaultPrepTime: "وقت التحضير الافتراضي",
        qualityNotes: "ملاحظات الجودة",
        attachments: "المرفقات",
        attachmentsCount: "{{count}} ملف",
        prepAdded: "مُضاف",
        noPrep: "غير مُضاف",
        noNotes: "—",
      },
      confirmModal: {
        title: "تأكيد إرسال الإعداد",
        subtitle: "هل أنت متأكد أنك تريد إرسال هذه العناصر؟",
        description:
          "بمجرد الإرسال، سيتم إضافة العناصر إلى المخزون وستصبح متاحة للاستخدام في التحويلات.",
        cancel: "لا ، الاستمرار في التعديل",
        confirm: "نعم ، إرسال العناصر",
      },
      successModal: {
        title: "تم إكمال إعداد التحضير بنجاح",
        description:
          "تم إكمال إعداد التحضير. الآن يمكن استخدامه في المخزون أو التحويلات.",
        itemsCompletedTitle: "تم إكمال إعداد {{count}} عناصر بنجاح",
        itemsCompletedDescription:
          "هذه العناصر الـ {{count}} أصبحت جاهزة الآن لتتبع المخزون والتحويلات.",
        remainingNotePrefix: "*{{count}} عناصر لا تزال تحتاج إلى إعداد:",
        remainingNoteSuffix:
          "يمكنك المتابعة الآن أو العودة إليها في أي وقت من قائمة العناصر المُحضّرة.",
        viewItem: "عرض العنصر",
        setUpRemaining: "إعداد المتبقي",
      },
      footer: {
        itemsWithIngredients: "{{count}} / {{total}} عناصر بمكونات",
        itemsCompleted: "{{count}} / {{total}} عناصر مكتملة",
        itemsReadyToSubmit: "{{count}} عناصر جاهزة للإرسال",
      },
      exitWithoutSavingModal: {
        title: "الخروج بدون حفظ؟",
        subTitle: "يحتوي هذا النموذج على تفاصيل غير محفوظة.",
        description: "سيؤدي الخروج الآن إلى حذف جميع البيانات المدخلة نهائياً.",
        cancel: "متابعة التعديل",
        confirm: "تجاهل والخروج",
      },
      saveDraftModal: {
        title: "تم حفظ المسودة!",
        subTitle: "تم حفظ تقدمك كمسودة.",
        description: "يمكنك العودة لاحقاً لمتابعة تعديل إعداد التحضير.",
        cancel: "الخروج من النموذج",
        confirm: "متابعة التعديل",
      },
      completeDraftModal: {
        title: "لديك إعداد تحضير غير مكتمل!",
        subTitle: "بدأت إعداد العناصر لكن لم تُكملها.",
        description: "أكمل المسودة الحالية أو ابدأ إعداد تحضير جديداً.",
        cancel: "بدء إعداد جديد",
        confirm: "إكمال النموذج",
      },
    },
    create: {
      title: "إنشاء عنصر مُحضّر",
      addItemNames: "إضافة اسماء العناصر المُحضّرة",
      addItemDetails: "إضافة تفاصيل العنصر المُحضّر",
      Step2Content:
        "تعيين وحدات القياس، ظروف التخزين، وإعدادات الاستخدام في الوصفات لهذا العنصر المُحضّر.",
      outputUomPlaceholder: "اختر الوحدة (كجم، لتر، قطعة، إلخ)",
      canBeUsedInRecipesHint:
        "يحدد إذا كان يمكن اختيار هذا العنصر ضمن الوصفات.",
      storageConditionPlaceholder: "اختر (مبرد، مجمد، إلخ)",
      storageConditionHint: "ظرف التخزين المُوصى به لهذا العنصر.",
      inRecipes: "ضمن الوصفات",
      notInRecipes: "ليس ضمن الوصفات",
      branchVisible: "مرئي للفرع",
      notBranchVisible: "غير مرئي للفرع",
      selectPreparedItems: "اختر عنصر/عناصر مُحضّر/مُحضّرات",
      mixedSelections: "اختيار مختلط",
      confirmItemsSubmissionModal: {
        title: "تأكيد إرسال العناصر",
        subtitle: "هل أنت متأكد أنك تريد إرسال هذه العناصر؟",
        description:
          "بمجرد الإرسال، سيتم إضافة العناصر إلى المخزون وستصبح متاحة للاستخدام في التحويلات.",
        cancel: "لا ، الاستمرار في التعديل",
        confirm: "نعم ، إرسال العناصر",
      },
      successModal: {
        title: "تم إضافة العناصر المُحضّرة بنجاح",
        subtitle: "*للبدء في استخدامها ، قم بإعداد التحضير.",
        description:
          "تم إضافة العنصر ، لكنه ليس جاهزًا للتتبع المخزون أو التحويلات بعد.",
        cancel: "عرض العناصر",
        confirm: "إعداد التحضير",
      },
    },
    edit: {
      title: "تعديل عنصر مُحضّر",
      itemNames: "أسماء العنصر المُحضّر",
      successModal: {
        title: "تم تحديث العنصر المُحضّر بنجاح",
        description:
          "تم حفظ تغييراتك. تفاصيل العنصر المُحضّر محدّثة الآن.",
        viewItem: "عرض العنصر",
      },
      steps: {
        ingredients: "المكونات",
        outputAndPrep: "الكمية والتحضير",
        review: "المراجعة",
      },
      confirmModal: {
        title: "تأكيد تحديث العنصر",
        subtitle: "هل أنت متأكد أنك تريد حفظ هذه التغييرات؟",
        description: "سيتم تحديث تفاصيل العنصر المُحضّر.",
        cancel: "لا، الاستمرار في التعديل",
        confirm: "نعم، حفظ التغييرات",
      },
    },
  },

  batchDetails: {
    recordOutput: "تسجيل الإنتاج",
    tabs: {
      quantity_ingredients: "الكمية والمكونات",
      details_activity: "التفاصيل وسجل النشاط",
    },
    quantitySummary: "ملخص الكمية",
    plannedOutput: "الإنتاج المخطط",
    actualOutput: "الإنتاج الفعلي",
    varianceQty: "كمية التباين",
    actualYield: "العائد الفعلي",
    lossReason: "سبب الفاقد",
    noProductionDetailsYet: "لا توجد تفاصيل إنتاج بعد",
    noProductionDetailsDescription: "ستظهر هذه القيم بمجرد اكتمال الإنتاج.",
    otherExplanation: "تفسير آخر",
    financialSummary: "الملخص المالي",
    actualQty: "الكمية الفعلية",
    totalProductionCost: "إجمالي تكلفة الإنتاج",
    actualCostPerOutputUom: "التكلفة الفعلية / وحدة المخرج",
    ingredients: "المكونات",
    table: {
      name: "اسم العنصر",
      plannedQty: "الكمية المخططة",
      currentAcc: "متوسط التكلفة الحالي",
      estIngredientCost: "التكلفة التقديرية للمكون",
    },
    batchDetails: "تفاصيل الدفعة",
    outputUom: "وحدة المخرج",
    outputUomDescription: "الوحدة التي يُنتج بها العنصر المحضّر.",
    outputSku: "رمز المخرج",
    productionDate: "تاريخ الإنتاج",
    productionDateDescription: "التاريخ المُدخل أثناء تسجيل الإنتاج",
    completedBy: "أُكمل بواسطة",
    notesAndInstructions: "الملاحظات والتعليمات",
    productionNotes: "ملاحظات الإنتاج",
    attachments: "المرفقات / الصور",
    noNotes: "لا توجد ملاحظات أو مرفقات",
    noNotesDescription:
      "سيتم عرض ملاحظات الإنتاج والتعليمات هنا بعد تسجيل الإنتاج.",
    activity: {
      planCreated: "تم إنشاء خطة الإنتاج",
      produceCompleted: "اكتمل إنتاج المخرج",
      lossRecorded: "تم تسجيل فاقد الإنتاج",
      recordOutputCompleted: "اكتمل تسجيل الإنتاج",
      updated: "تم تحديث الدفعة",
    },
  },

  // Cost Centers
  costCenters: {
    title: "مراكز التكلفة",
    createCostCenter: "إنشاء مركز تكلفة",
    centerName: "اسم المركز",
    code: "الرمز",
    description: "الوصف",
    budget: "الميزانية",
    spent: "المنصرف",
    remaining: "المتبقي",
    parent: "مركز التكلفة الأب",
  },

  // Expenses
  expenses: {
    title: "المصروفات",
    createExpense: "إنشاء مصروف",
    editExpense: "تعديل المصروف",
    description: "الوصف",
    amount: "المبلغ",
    currency: "العملة",
    date: "التاريخ",
    costCenter: "مركز التكلفة",
    category: "الفئة",
    attachments: "المرفقات",
    approvedBy: "تمت الموافقة بواسطة",
    createdBy: "أنشئ بواسطة",
  },

  // Settings
  settings: {
    title: "الإعدادات",
    general: "عام",
    appearance: "المظهر",
    language: "اللغة",
    theme: "السمة",
    themeLight: "فاتح",
    themeDark: "داكن",
    themeSystem: "تلقائي",
    notifications: "الإشعارات",
    security: "الأمان",
    changePassword: "تغيير كلمة المرور",
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmNewPassword: "تأكيد كلمة المرور الجديدة",
  },

  // Roles
  roles: {
    super_admin: "مدير عام",
    admin: "مسؤول",
    branch_manager: "مدير فرع",
    branch_staff: "موظف فرع",
    ck_manager: "مدير المطبخ المركزي",
    ck_staff: "موظف المطبخ المركزي",
    guest: "زائر",
  },

  // Profile
  profile: {
    title: "الملف الشخصي",
    editProfile: "تعديل الملف الشخصي",
    avatar: "الصورة الرمزية",
    personalInfo: "المعلومات الشخصية",
    accountSettings: "إعدادات الحساب",
    role: "الدور",
    branch: "الفرع",
    joinedOn: "انضم في {{date}}",
  },

  // Languages
  languages: {
    en: "English",
    ar: "العربية",
  },

  // Errors
  errors: {
    unauthorized: "غير مصرح لك بالوصول إلى هذه الصفحة",
    forbidden: "الوصول مرفوض",
    notFound: "الصفحة غير موجودة",
    serverError: "خطأ في الخادم. يرجى المحاولة مرة أخرى لاحقاً.",
    networkError: "خطأ في الشبكة. يرجى التحقق من اتصالك.",
    sessionExpired: "انتهت صلاحية جلستك. يرجى تسجيل الدخول مرة أخرى.",
  },

  // Currency
  currency: {
    AED: "درهم",
    USD: "دولار",
    EUR: "يورو",
    SAR: "ريال",
  },

  // DatePicker / Calendar
  datePicker: {
    months: [
      "يناير",
      "فبراير",
      "مارس",
      "أبريل",
      "مايو",
      "يونيو",
      "يوليو",
      "أغسطس",
      "سبتمبر",
      "أكتوبر",
      "نوفمبر",
      "ديسمبر",
    ],
    daysOfWeek: [
      "الأحد",
      "الإثنين",
      "الثلاثاء",
      "الأربعاء",
      "الخميس",
      "الجمعة",
      "السبت",
    ],
  },

  producedOutput: {
    title: "المخرجات المنتجة",
    produceOutput: "إنتاج مخرجات",
    searchPlaceholder: "البحث برقم الدفعة، اسم المخرج، رمز المخرج",
    filterVariance: "تصفية التباين",
    filterProductionDate: "تاريخ الإنتاج",
    selectCategory: "اختر الفئة",
    selectSubcategory: "اختر الفئة الفرعية",
    noVariance: "لا يوجد تباين",
    preparationLoss: "فاقد التحضير",
    variancePositive: "إيجابي",
    varianceNegative: "سلبي",
    recordOutput: "سجل الإنتاج",
    totalItems: "الإجمالي: {{count}} عنصر",
    awaitingCount: "{{count}} بانتظار الإنتاج",
    exportSuccess: "تم تصدير المخرجات المنتجة بنجاح",
    status: {
      awaiting: "بانتظار الإنتاج",
      completed: "إنتاج مكتمل",
    },
    awaiting: {
      actualYield: "بانتظار انتهاء الإنتاج",
      variance: "يُسجل عند الإكمال",
      actualCostPerUom: "يُحسب عند الإكمال",
    },
    columns: {
      batchNumber: "رقم الدفعة",
      outputName: "اسم المخرج",
      actualYield: "الإنتاج الفعلي",
      variance: "التباين",
      totalProductionCost: "إجمالي تكلفة الإنتاج",
      actualCostPerUom: "التكلفة الفعلية / وحدة المخرج",
      productionDate: "تاريخ الإنتاج",
      actions: "الإجراءات",
    },
    emptyState: {
      title: "لم يتم إنتاج أي شيء بعد",
      description:
        "ستُعرض هنا المخرجات المنتجة من العناصر المحضّرة. ابدأ باختيار عنصر محضّر وإنتاج مخرجاته.",
      createButton: "إنتاج مخرجات",
      noResults: "لا توجد نتائج",
    },
    export: {
      batchNumber: "رقم الدفعة",
      outputName: "اسم المخرج",
      status: "الحالة",
      actualYield: "الإنتاج الفعلي",
      variance: "التباين",
      totalProductionCost: "إجمالي تكلفة الإنتاج",
      actualCostPerUom: "التكلفة الفعلية / وحدة المخرج",
      productionDate: "تاريخ الإنتاج",
    },
    produceFlow: {
      formTitle: "إنتاج مخرجات - {{details}}",
      submit: "إرسال",
      costUnavailable: "غير متاح",
      selectItem: {
        title: "اختر العنصر للإنتاج",
        description:
          "اختر العنصر المحضّر الذي تريد إنتاجه. سيتم جلب كمية الإعداد والمكونات تلقائياً.",
        preparedItemColumn: "اختر العنصر المحضّر",
        startProduction: "بدء الإنتاج",
      },
      steps: {
        setPlannedQty: {
          title: "تعيين الكمية المخططة",
          description:
            "حدد الكمية المخططة وراجع كميات المكونات والتكاليف والمخزون.",
        },
        reviewOutput: {
          title: "مراجعة المخرج",
          description: "راجع مخرج الإنتاج قبل الإكمال.",
          placeholder: "خطوة مراجعة المخرج قريباً.",
        },
        recordOutput: {
          step2: "خطوة 2",
          title: "تسجيل الإنتاج",
          description:
            "حدد الكمية الفعلية وأكمل تفاصيل الإنتاج وراجع المخرج قبل الإرسال.",
        },
      },
      plannedQty: {
        sectionTitle: "كمية المخرج المخططة",
        formulaHint: "الكمية المخططة = كمية الإعداد × مضاعف الدفعة",
        plannedQtyLabel: "الكمية المخططة",
        placeholder: "مثال 12.50",
        setupQtyLabel: "كمية الإعداد",
        setupQtySubtitle: "تم جلبها من إعداد التحضير",
        batchMultiplierLabel: "مضاعف الدفعة",
        batchMultiplierSubtitle: "محسوب تلقائياً",
      },
      ingredients: {
        title: "المكونات",
        countBadge: "{{count}} عنصر",
        formulaHint: "الكمية المخططة = كمية الإعداد × <box>{{multiplier}}</box>",
        itemName: "اسم العنصر",
        setupQty: "كمية الإعداد",
        plannedQty: "الكمية المخططة",
        availableStock: "المخزون المتاح",
        currentAcc: "ACC الحالي",
        estimatedCost: "التكلفة التقديرية للمكون",
        stockStatus: "حالة المخزون",
      },
      stockStatus: {
        available: "متاح",
        insufficient: "غير كافٍ",
        outOfStock: "نفد المخزون",
      },
      footer: {
        shortOnStock: "{{count}} مكونات ينقصها المخزون",
        insufficient: "{{count}} مكونات غير كافية",
      },
      confirmModal: {
        title: 'تأكيد خطة الإنتاج لـ "{{itemName}}"',
        subtitle: "هل أنت متأكد أنك تريد إرسال هذه الخطة؟",
        description:
          "بعد الإرسال، سيتم خصم مخزون المكونات من المطبخ المركزي. يُسجَّل المخرج الفعلي بعد الإنتاج.",
        footnote: "*لا يمكن تعديل هذا الإجراء بعد الإكمال",
        cancel: "لا، متابعة التعديل",
        confirm: "تأكيد وحفظ الخطة",
      },
      confirmPurchaseUnits: {
        title: "تأكيد وحدات الشراء",
        description:
          "راجع وحدات المخزون التي ستُستخدم في هذا الإنتاج. يمكنك تعديل الاختيار عند الحاجة.",
        plannedQtyTitle: "{{name}} / الكمية المخططة",
        requiredQtyHint: "الكمية المطلوبة لهذا الإنتاج",
        shortfallWarning:
          "الكمية المدخلة أقل من الكمية المخططة بمقدار {{amount}} {{unit}}.",
        stockBreakdownTitle: "تفصيل المخزون المتاح",
        stockBreakdownHint:
          "راجع كيف ستُخصم الكمية المخططة من المخزون المتاح. عدّل الاختيار عند الحاجة.",
        packsAvailable: "{{count}} {{unit}} متاح",
        conversionNote:
          "أي وحدة شراء / عبوة محددة ستُحوَّل إلى كمية أساسية / فضفاضة في المخزون بعد استخدامها في الإنتاج.",
        confirm: "تأكيد وبدء الإنتاج",
      },
      successModal: {
        title: 'تم حفظ خطة الإنتاج لـ "{{itemName}}"',
        description:
          "اطبع ورقة التحضير وابدأ التحضير في المطبخ. عند انتهاء الإنتاج، عد لتسجيل المخرج الفعلي.",
        viewDetails: "عرض التفاصيل",
        printPlan: "طباعة الخطة",
      },
      planPdf: {
        title: "خطة إنتاج {{itemName}}",
        preparedItem: "العنصر المحضّر",
        sku: "SKU",
        plannedQty: "الكمية المخططة",
        outputUom: "وحدة قياس المخرج",
        ingredientName: "اسم العنصر",
        ingredientPlannedQty: "الكمية المخططة",
      },
      exitWithoutSaving: {
        title: "الخروج دون حفظ؟",
        subTitle: "يحتوي هذا النموذج على بيانات غير محفوظة.",
        description: "الخروج الآن سيحذف جميع البيانات المدخلة نهائياً.",
        cancel: "تجاهل والخروج",
        confirm: "البقاء",
      },
      confirmSubmitRecordModal: {
        title: "تأكيد إنتاج المخرج {{itemName}}",
        subtitle: "هل أنت متأكد أنك تريد إرسال هذا الإنتاج؟",
        description:
          "بعد الإرسال، سيتم إضافة الكمية الفعلية المنتجة إلى المخزون.",
        footnote: "*لا يمكن تعديل هذا الإجراء بعد الإكمال",
        cancel: "لا، متابعة التعديل",
        confirm: "نعم، إرسال الإنتاج",
      },
      recordOutputSuccessModal: {
        title: "تم إرسال إنتاج المخرج {{itemName}}",
        description: "تم إنتاج المخرج. تم تحديث المخزون.",
        viewDetails: "عرض التفاصيل",
      },
      recordOutput: {
        sectionTitle: "الكمية المنتجة الفعلية",
        actualQtyLabel: "الكمية الفعلية",
        actualQtyHint: "الكمية النهائية المنتجة بعد التحضير.",
        productionDateHint: "تاريخ الإنتاج المدخل أثناء تسجيل الإنتاج",
        actualQtyPlaceholder: "مثال 12",
        lossReasonLabel: "سبب الفاقد",
        lossReasonPlaceholder: "اختر السبب",
        lossReasonOtherLabel: "تفسير آخر",
        lossReasonOtherPlaceholder: "اكتب سبب الفاقد",
        productionInfoTitle: "معلومات الإنتاج",
        productionDateLabel: "تاريخ الإنتاج",
        productionNotesLabel: "ملاحظات الإنتاج",
        productionNotesPlaceholder:
          "أضف أي ملاحظات حول عملية الإنتاج هذه: تفاصيل التحضير، أو تغييرات المكونات، أو المشكلات التي واجهتها.",
        attachmentsLabel: "المرفقات / الصور",
        outputSummaryTitle: "ملخص المخرج",
        plannedOutput: "الإنتاج المخطط",
        actualOutput: "الإنتاج الفعلي",
        varianceQty: "كمية التباين",
        varianceFormula: "الكمية الفعلية - الكمية المخططة",
        actualYield: "العائد الفعلي",
        totalIngredientsCost: "إجمالي تكلفة المكونات",
        actualCostPerUom: "التكلفة الفعلية / وحدة المخرج",
        validation: {
          actualQtyRequired: "الكمية الفعلية مطلوبة",
          actualQtyInvalid: "أدخل كمية عشرية صحيحة",
          actualQtyPositive: "لا يمكن أن تكون الكمية الفعلية صفراً أو سالبة",
          actualQtyExceedsPlanned:
            "لا يمكن أن تكون الكمية الفعلية أكبر من كمية الإنتاج المخططة",
          productionDateRequired: "تاريخ الإنتاج مطلوب",
          lossReasonRequired: "سبب الفاقد مطلوب",
          lossReasonOtherRequired: "يرجى كتابة سبب الفاقد",
        },
        footer: {
          noVariance: "الكمية الفعلية تطابق الكمية المخططة. لم يُسجَّل تباين.",
          productionLoss:
            "تم تسجيل خسارة إنتاج. {{qty}} {{uom}} (-{{percentage}}%) أقل من الخطة.",
        },
      },
    },
  },
};
